(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2765,2576,2597,5901],{

/***/ 30979:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ catalog; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/@tanstack/react-query/build/lib/useIsFetching.mjs
var useIsFetching = __webpack_require__(38347);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/components/CheckboxField/index.ts + 2 modules
var CheckboxField = __webpack_require__(72182);
// EXTERNAL MODULE: ../../libs/matcha/components/Divider/index.ts + 1 modules
var Divider = __webpack_require__(76305);
// EXTERNAL MODULE: ../../libs/templates/GettingStarted/index.ts + 2 modules
var GettingStarted = __webpack_require__(42576);
// EXTERNAL MODULE: ../../libs/templates/Footer/index.ts
var Footer = __webpack_require__(4009);
// EXTERNAL MODULE: ../../libs/templates/Navigation/index.ts + 91 modules
var Navigation = __webpack_require__(87303);
// EXTERNAL MODULE: ../../libs/tracking/scripts/index.ts + 2 modules
var scripts = __webpack_require__(17397);
// EXTERNAL MODULE: ../../libs/next-shared/layout/index.ts
var layout = __webpack_require__(56052);
// EXTERNAL MODULE: ../../libs/matcha/components/SearchBar/index.ts + 1 modules
var SearchBar = __webpack_require__(54086);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Hero/index.tsx + 2 modules
var Hero = __webpack_require__(84629);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/Catalog/LandingPage/components/Hero/Hero.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








var copy = {
  heading: "Hundreds of integrations",
  description: "Power your tools with the data they need.",
  partnerPage: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: ["Need a hand getting your integrations set up? Find a", " ", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
      href: "https://segment.partnerpage.io/",
      children: "consulting partner"
    }), " ", "to help."]
  })
};
var Hero_Hero = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var query = _ref.query,
      isFetching = _ref.isFetching,
      onQueryChange = _ref.onQueryChange;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
    ref: ref,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Hero/* default */.ZP, {
      variant: "centered",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Hero/* Copy */.CK, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h1",
          variant: "h1",
          children: copy.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          tag: "p",
          variant: "pExtraLarge",
          children: copy.description
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Hero/* Contents */.AU, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchWrapper, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchBar/* default */.Z, {
            dataHook: "catalog-search-bar",
            appearance: "twilioLight",
            placeholder: "Search integrations...",
            "aria-label": "search",
            name: "catalog_integrations_query",
            id: "catalog_integrations_input",
            value: query,
            isLoading: isFetching,
            onChange: function onChange(_e, value) {
              return onQueryChange(value !== null && value !== void 0 ? value : "");
            },
            onClear: function onClear() {
              return onQueryChange("");
            },
            expanded: true
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledCopyTextBase, {
          centered: true,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            tag: "p",
            variant: "pLarge",
            children: copy.partnerPage
          })
        })]
      })]
    })
  });
});

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ere1irs2"
} : 0)("background-color:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.neutrals.white[100];
}, ";" + ( true ? "" : 0));

var SearchWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ere1irs1"
} : 0)( true ? {
  name: "1mmi4d2",
  styles: "max-width:520px;width:100%"
} : 0);

var StyledCopyTextBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* default */.ZP,  true ? {
  target: "ere1irs0"
} : 0)("padding-top:32px;position:relative;z-index:1;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("md");
}, "{padding-top:56px;}" + ( true ? "" : 0));

/* harmony default export */ var components_Hero_Hero = (Hero_Hero);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/render/dom/motion-minimal.mjs + 21 modules
var motion_minimal = __webpack_require__(48714);
// EXTERNAL MODULE: ../../libs/matcha/recipes/TableOfContents/index.ts + 8 modules
var TableOfContents = __webpack_require__(55979);
// EXTERNAL MODULE: ../../libs/utils/useMaskOnScroll/index.ts + 1 modules
var useMaskOnScroll = __webpack_require__(63009);
;// CONCATENATED MODULE: ./src/views/Catalog/LandingPage/components/List/ListContext.tsx


var ListContext = /*#__PURE__*/(0,react.createContext)(null);
var ListContextProvider = function ListContextProvider(_ref) {
  var active = _ref.active,
      setActive = _ref.setActive,
      children = _ref.children;
  var context = (0,react.useMemo)(function () {
    return {
      active: active,
      setActive: setActive
    };
  }, [active, setActive]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ListContext.Provider, {
    value: context,
    children: children
  });
};
var useListContext = function useListContext() {
  var context = (0,react.useContext)(ListContext);

  if (!context) {
    throw new Error("ListContext isn't available.");
  }

  return context;
};
;// CONCATENATED MODULE: ./src/views/Catalog/LandingPage/components/List/List.tsx


function List_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var List = function List(_ref) {
  var value = _ref.value,
      children = _ref.children,
      className = _ref.className,
      onChange = _ref.onChange;
  var scrollableContainerRef = (0,react.useRef)(null);
  var maskOnScroll = (0,useMaskOnScroll/* default */.Z)({
    wrapper: scrollableContainerRef,
    axis: "vertical",
    offset: "200px"
  });
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TableOfContents/* default */.ZP, {
    className: className,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TableOfContents/* Title */.Dx, {
      children: "Categories"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mask, {
      style: {
        WebkitMaskImage: maskOnScroll,
        maskImage: maskOnScroll
      },
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TableOfContentsList, {
        ref: scrollableContainerRef,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ListContextProvider, {
          active: value,
          setActive: onChange,
          children: children
        })
      })
    })]
  });
};

var TableOfContentsList = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(TableOfContents/* List */.aV,  true ? {
  target: "e1fnwo101"
} : 0)( true ? {
  name: "q0gy3v",
  styles: "overflow-y:auto;max-height:calc(100vh - 368px)"
} : 0);

var Mask = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(motion_minimal.m.div,  true ? {
  target: "e1fnwo100"
} : 0)( true ? "" : 0);

/* harmony default export */ var List_List = (List);
;// CONCATENATED MODULE: ./src/views/Catalog/LandingPage/components/List/ListItem.tsx




var ListItem = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var value = _ref.value,
      children = _ref.children,
      href = _ref.href;
  var elementRef = (0,react.useRef)(null);

  var _useListContext = useListContext(),
      active = _useListContext.active,
      setActive = _useListContext.setActive;

  var isActive = value === active;
  (0,react.useImperativeHandle)(ref, function () {
    return elementRef.current;
  });
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TableOfContents/* ListItem */.HC, {
    ref: elementRef,
    active: isActive,
    href: href,
    onClick: function onClick(e) {
      e.preventDefault();

      if (!isActive) {
        setActive === null || setActive === void 0 ? void 0 : setActive(value, elementRef);
      }
    },
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TableOfContents/* LeftContent */.PJ, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TableOfContents/* Text */.xv, {
        variant: isActive ? "buttonLarge" : "formInput",
        children: children
      })
    })
  });
});
/* harmony default export */ var List_ListItem = (ListItem);
;// CONCATENATED MODULE: ./src/views/Catalog/LandingPage/components/DesktopCategoriesList/DesktopCategoriesList.tsx




var DesktopCategoriesList = function DesktopCategoriesList(_ref) {
  var categoryId = _ref.categoryId,
      categories = _ref.categories,
      onCategoryChange = _ref.onCategoryChange;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(List_List, {
    value: categoryId !== null && categoryId !== void 0 ? categoryId : "all",
    onChange: onCategoryChange,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(List_ListItem, {
      value: "all",
      href: "/catalog",
      children: "All"
    }), categories.map(function (_ref2) {
      var slug = _ref2.slug,
          name = _ref2.name;
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(List_ListItem, {
        value: slug,
        href: "/catalog/".concat(slug),
        children: name
      }, slug);
    })]
  });
};

/* harmony default export */ var DesktopCategoriesList_DesktopCategoriesList = (DesktopCategoriesList);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(12741);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Common.ts + 14 modules
var Common = __webpack_require__(6580);
// EXTERNAL MODULE: ../../libs/matcha/components/Input/index.ts + 2 modules
var Input = __webpack_require__(94261);
// EXTERNAL MODULE: ../../libs/matcha/components/Select/index.ts + 9 modules
var Select = __webpack_require__(44502);
// EXTERNAL MODULE: ../../libs/matcha/components/Select/useSelect/index.ts + 3 modules
var useSelect = __webpack_require__(27431);
;// CONCATENATED MODULE: ./src/views/Catalog/LandingPage/components/MobileCategoriesList/MobileCategoriesList.tsx




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










var MobileCategoriesList = function MobileCategoriesList(_ref) {
  var categories = _ref.categories,
      categoryId = _ref.categoryId,
      onCategoryChange = _ref.onCategoryChange;
  var options = (0,react.useMemo)(function () {
    return [{
      text: "All",
      value: "all"
    }].concat((0,toConsumableArray/* default */.Z)(categories.map(function (c) {
      return {
        text: c.name,
        value: c.slug
      };
    })));
  }, [categories]);
  var option = (0,react.useMemo)(function () {
    var _options$find;

    return (_options$find = options.find(function (o) {
      return o.value === categoryId;
    })) !== null && _options$find !== void 0 ? _options$find : options[0];
  }, [categoryId, options]);

  var useControlledState = function useControlledState(state) {
    return _objectSpread(_objectSpread({}, state), {}, {
      selected: [option]
    });
  };

  var _useSelect = (0,useSelect/* default */.Z)({
    initialSelected: [option],
    useControlledState: useControlledState,
    options: options,
    id: "categories-select",
    onSelect: function onSelect(o) {
      var _o$0$value, _o$;

      onCategoryChange((_o$0$value = (_o$ = o[0]) === null || _o$ === void 0 ? void 0 : _o$.value) !== null && _o$0$value !== void 0 ? _o$0$value : null);
    },
    config: {
      mobileConfirmationBehaviour: false
    },
    label: "categories"
  }),
      state = _useSelect.state,
      getControlProps = _useSelect.getControlProps,
      filteredOptions = _useSelect.filteredOptions,
      getSelectProps = _useSelect.getSelectProps;

  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MobileCategoriesList_Wrapper, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input/* default */.Z, _objectSpread({
      name: "categories-searchbox",
      type: "search",
      resetable: state.filterValue !== "",
      expanded: true,
      clearIcon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Select/* ClearSelect */.kr, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Common/* ClearIcon */.Rk, {
          size: "small",
          color: theme.palette.neutrals.white[100]
        })
      }),
      rightSecondIcon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Common/* ChevronDownIcon */.v4, {})
    }, getControlProps({
      placeholder: "Select an option..."
    }))), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Select/* default */.ZP, _objectSpread({
      id: "categories-dropdown",
      name: "select-example",
      options: options,
      filteredOptions: filteredOptions,
      displayMode: state.displayMode,
      open: state.open
    }, getSelectProps()))]
  });
};

var MobileCategoriesList_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eozloyu0"
} : 0)( true ? "" : 0);

/* harmony default export */ var MobileCategoriesList_MobileCategoriesList = (MobileCategoriesList);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../libs/matcha/components/ButtonText/index.ts
var ButtonText = __webpack_require__(74870);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/CategoryHeader/CategoryHeader.views.tsx


function CategoryHeader_views_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var CategoryHeader = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e2ifbe12"
} : 0)(function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("lg");
}, "{display:flex;justify-content:space-between;align-items:center;}width:100%;" + ( true ? "" : 0));
var Title = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e2ifbe11"
} : 0)( true ? {
  name: "ti75j2",
  styles: "margin:0"
} : 0);
var ButtonWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e2ifbe10"
} : 0)(function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("lg");
}, "{min-width:110px;margin-left:20px;}" + ( true ? "" : 0));
/* harmony default export */ var CategoryHeader_views = ((/* unused pure expression or super */ null && (CategoryHeader)));
;// CONCATENATED MODULE: ../../libs/matcha/recipes/CategoryHeader/CategoryHeader.tsx


var _excluded = ["children", "onClick", "size"];

function CategoryHeader_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function CategoryHeader_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? CategoryHeader_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : CategoryHeader_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var Button = function Button(_ref) {
  var children = _ref.children,
      onClick = _ref.onClick,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "small" : _ref$size,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonWrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonText/* default */.Z, CategoryHeader_objectSpread(CategoryHeader_objectSpread({
      onClick: onClick,
      size: size,
      variant: "mono"
    }, props), {}, {
      iconEnd: Common/* ChevronRightIcon */.XC,
      children: children
    }))
  });
};
;// CONCATENATED MODULE: ../../libs/matcha/recipes/CategoryHeader/index.ts


CategoryHeader.displayName = "CategoryHeaderBase";
Button.displayName = "CategoryHeader.Button";
Title.displayName = "CategoryHeader.Title";

// EXTERNAL MODULE: ../../libs/matcha/recipes/CardsGrid/index.ts + 2 modules
var CardsGrid = __webpack_require__(75420);
;// CONCATENATED MODULE: ./src/views/Catalog/LandingPage/components/CatalogGrid/CatalogGrid.tsx


function CatalogGrid_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var CatalogGrid = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eszmrhj1"
} : 0)("display:grid;align-content:flex-start;gap:80px;padding:20px 24px 72px;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("sm");
}, "{padding:40px;}", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("lg");
}, "{padding:80px 0;}" + ( true ? "" : 0));

/* harmony default export */ var CatalogGrid_CatalogGrid = (CatalogGrid);
var Group = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eszmrhj0"
} : 0)( true ? {
  name: "2lune6",
  styles: "display:grid;gap:24px"
} : 0);
// EXTERNAL MODULE: ./src/views/Catalog/components/IntegrationCard/IntegrationCard.tsx
var IntegrationCard = __webpack_require__(40620);
;// CONCATENATED MODULE: ./src/views/Catalog/LandingPage/components/GroupedGrid/GroupedGrid.tsx


function GroupedGrid_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










var GroupedGrid = function GroupedGrid(_ref3) {
  var onCategoryChange = _ref3.onCategoryChange,
      nextPageTrigger = _ref3.nextPageTrigger,
      flattenedPages = _ref3.flattenedPages,
      isEmpty = _ref3.isEmpty,
      destination = _ref3.destination,
      source = _ref3.source,
      isLoading = _ref3.isLoading;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CatalogGrid_CatalogGrid, {
    "aria-live": "polite",
    "aria-busy": isLoading,
    children: [flattenedPages === null || flattenedPages === void 0 ? void 0 : flattenedPages.map(function (_ref4, index) {
      var category = _ref4.category,
          integrations = _ref4.integrations;
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CategoryGroup, {
        category: category,
        integrations: integrations,
        onCategoryChange: onCategoryChange
      }, index);
    }), isEmpty && !destination && !source && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(EmptyView, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NoMarginTypography, {
        variant: "h4",
        children: "Sorry, we couldn\u2019t find anything that fit your search."
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NoMarginTypography, {
        variant: "pMedium",
        children: "Please select at least one integration type."
      })]
    }), nextPageTrigger]
  });
};

/* harmony default export */ var GroupedGrid_GroupedGrid = (GroupedGrid);

var CategoryGroup = function CategoryGroup(_ref5) {
  var category = _ref5.category,
      onCategoryChange = _ref5.onCategoryChange,
      integrations = _ref5.integrations;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Group, {
    children: [category && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CategoryHeader, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, {
        variant: "h4",
        children: category.name
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ShowMoreButton, {
        integrationsLength: integrations.length,
        onClick: function onClick() {
          return onCategoryChange(category.slug);
        },
        children: "View more"
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardsGrid/* default */.Z, {
      limitItems: true,
      children: integrations.map(function (integration) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IntegrationCard/* default */.Z, {
          integration: integration
        }, integration.objectID);
      })
    })]
  });
};

var _ref =  true ? {
  name: "eivff4",
  styles: "display:none"
} : 0;

var _ref2 =  true ? {
  name: "eivff4",
  styles: "display:none"
} : 0;

var ShowMoreButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Button,  true ? {
  target: "eqcsahr2"
} : 0)(function (_ref6) {
  var theme = _ref6.theme;
  return theme.breakpoints.down("sm");
}, "{", function (_ref7) {
  var integrationsLength = _ref7.integrationsLength;
  return integrationsLength < CardsGrid/* CONFIG.itemsLimit.mobile */.k.itemsLimit.mobile && _ref2;
}, ";}", function (_ref8) {
  var theme = _ref8.theme;
  return theme.breakpoints.up("md");
}, "{", function (_ref9) {
  var integrationsLength = _ref9.integrationsLength;
  return integrationsLength < CardsGrid/* CONFIG.itemsLimit.desktop */.k.itemsLimit.desktop && _ref;
}, ";}" + ( true ? "" : 0));

var NoMarginTypography = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "eqcsahr1"
} : 0)( true ? {
  name: "ti75j2",
  styles: "margin:0"
} : 0);

var EmptyView = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eqcsahr0"
} : 0)( true ? {
  name: "wkmo7m",
  styles: "display:grid;gap:48px"
} : 0);
;// CONCATENATED MODULE: ./src/views/Catalog/LandingPage/components/CategoryGrid/CategoryGrid.tsx


function CategoryGrid_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var CategoryGrid = function CategoryGrid(_ref) {
  var category = _ref.category,
      nextPageTrigger = _ref.nextPageTrigger,
      flattenedPages = _ref.flattenedPages,
      isEmpty = _ref.isEmpty,
      isLoading = _ref.isLoading;

  if (!category) {
    return null;
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CatalogGrid_CatalogGrid, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Group, {
      "aria-live": "polite",
      "aria-busy": isLoading,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CategoryHeader, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, {
          variant: "h4",
          children: category.name
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardsGrid/* default */.Z, {
        limitItems: false,
        children: flattenedPages === null || flattenedPages === void 0 ? void 0 : flattenedPages.map(function (integration) {
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IntegrationCard/* default */.Z, {
            integration: integration,
            isInCategoryGrid: true
          }, integration.objectID);
        })
      }), isEmpty && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CategoryGrid_NoMarginTypography, {
        variant: "pMedium",
        children: "Sorry, we couldn\u2019t find anything that fit your search."
      }), nextPageTrigger]
    })
  });
};

/* harmony default export */ var CategoryGrid_CategoryGrid = (CategoryGrid);

var CategoryGrid_NoMarginTypography = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e1mrpe6k0"
} : 0)( true ? {
  name: "ti75j2",
  styles: "margin:0"
} : 0);
;// CONCATENATED MODULE: ./src/views/Catalog/LandingPage/components/LoadingOverlay/LoadingOverlay.tsx


function LoadingOverlay_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }



var LoadingOverlay_ref =  true ? {
  name: "o9ww1u",
  styles: "opacity:0.5"
} : 0;

var LoadingOverlay = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "erpp9x30"
} : 0)("opacity:0;background-color:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.twilio.gray[10];
}, ";position:absolute;top:0;left:0;bottom:0;right:0;width:100%;transition:opacity ease-in-out 0.3s;z-index:1;pointer-events:none;", function (_ref3) {
  var isFetching = _ref3.isFetching;
  return isFetching && LoadingOverlay_ref;
}, ";" + ( true ? "" : 0));

/* harmony default export */ var LoadingOverlay_LoadingOverlay = (LoadingOverlay);
;// CONCATENATED MODULE: ./src/views/Catalog/LandingPage/components/LoadingOverlay/index.ts

/* harmony default export */ var components_LoadingOverlay = (LoadingOverlay_LoadingOverlay);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var components_Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
;// CONCATENATED MODULE: ./src/views/Catalog/LandingPage/components/SearchGrid/EmptyResults.tsx


function EmptyResults_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }













var EmptyResults = function EmptyResults(_ref) {
  var query = _ref.query,
      onCategoryChange = _ref.onCategoryChange,
      entries = _ref.entries,
      hitsAmount = _ref.hitsAmount;
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  var hasEntries = entries ? entries.length > 0 : undefined;
  var moreHitsAvailable = hitsAmount && hitsAmount > 4;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmptyResults_NoMarginTypography, {
      variant: "pMedium",
      children: "Sorry, we couldn\u2019t find anything that fit your search."
    }), hasEntries && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CategoryHeader, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Title, {
          variant: "h4",
          children: [hitsAmount !== null && hitsAmount !== void 0 ? hitsAmount : null, " search results for \"", query, "\" in All categories"]
        }), moreHitsAvailable && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button, {
          onClick: function onClick() {
            return onCategoryChange("all");
          },
          children: "View all"
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardsGrid/* default */.Z, {
        limitItems: false,
        children: entries === null || entries === void 0 ? void 0 : entries.map(function (integration) {
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IntegrationCard/* default */.Z, {
            integration: integration
          }, integration.objectID);
        })
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Grid, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmptyResults_NoMarginTypography, {
        variant: "h4",
        gridArea: "heading1",
        children: "Can't find what you're looking for?"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmptyResults_NoMarginTypography, {
        variant: "h4",
        gridArea: "heading2",
        children: "Interested in partnering with us?"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmptyResults_NoMarginTypography, {
        variant: "pMedium",
        gridArea: "text1",
        children: "Let us know and we\u2019ll help you set up the integration you need."
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmptyResults_NoMarginTypography, {
        variant: "pMedium",
        gridArea: "text2",
        children: "Enable thousands of companies to instantly activate their first-party data in your app."
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmptyResults_ButtonWrapper, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Button/* default */.Z, {
          tag: "a",
          href: (0,getAbsoluteUrl/* default */.Z)("/requests/integrations/", pageConfig),
          size: "medium",
          color: "primary",
          variant: "filled",
          children: "Request a new integration"
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmptyResults_ButtonWrapper, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Button/* default */.Z, {
          tag: "a",
          href: (0,getAbsoluteUrl/* default */.Z)("/partners/developer-portal/", pageConfig),
          size: "medium",
          color: "primary",
          variant: "filled",
          children: "Visit our Developer Portal"
        })
      })]
    })]
  });
};

/* harmony default export */ var SearchGrid_EmptyResults = (EmptyResults);

var EmptyResults_NoMarginTypography = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e1u8nnx72"
} : 0)("margin:0;grid-area:", function (_ref2) {
  var gridArea = _ref2.gridArea;
  return gridArea;
}, ";" + ( true ? "" : 0));

var Grid = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1u8nnx71"
} : 0)("display:grid;row-gap:16px;column-gap:80px;grid-template-areas:'heading1' 'text1' 'button1' 'heading2' 'text2' 'button2';", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("lg");
}, "{grid-template-areas:'heading1 heading2' 'text1 text2' 'button1 button2';}", function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.up("xxl");
}, "{margin-right:160px;}" + ( true ? "" : 0));

var EmptyResults_ButtonWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1u8nnx70"
} : 0)( true ? {
  name: "12kdz71",
  styles: "margin-top:14px;margin-bottom:24px"
} : 0);
;// CONCATENATED MODULE: ./src/views/Catalog/LandingPage/components/SearchGrid/SearchGrid.tsx











var SearchGrid = function SearchGrid(_ref) {
  var query = _ref.query,
      category = _ref.category,
      onCategoryChange = _ref.onCategoryChange,
      isEmpty = _ref.isEmpty,
      nextPageTrigger = _ref.nextPageTrigger,
      flattenedPagesCategorySearch = _ref.flattenedPagesCategorySearch,
      flattenedPagesAllCategoriesSearch = _ref.flattenedPagesAllCategoriesSearch,
      emptyHits = _ref.emptyHits,
      isLoading = _ref.isLoading;
  var title = category ? "Search results for \"".concat(query, "\" in ").concat(category.name, " category") : "Search results for \"".concat(query, "\"");
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(NarrowCatalogGridBase, {
    "aria-live": "polite",
    "aria-busy": isLoading,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Group, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CategoryHeader, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, {
          variant: "h4",
          children: title
        })
      }), !isEmpty && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardsGrid/* default */.Z, {
          limitItems: false,
          children: flattenedPagesCategorySearch === null || flattenedPagesCategorySearch === void 0 ? void 0 : flattenedPagesCategorySearch.map(function (integration) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IntegrationCard/* default */.Z, {
              integration: integration,
              isInCategoryGrid: Boolean(category),
              query: query
            }, integration.objectID);
          })
        }), nextPageTrigger]
      })]
    }), isEmpty && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchGrid_EmptyResults, {
      onCategoryChange: onCategoryChange,
      query: query,
      entries: flattenedPagesAllCategoriesSearch,
      hitsAmount: emptyHits
    })]
  });
};

/* harmony default export */ var SearchGrid_SearchGrid = (SearchGrid);

var NarrowCatalogGridBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CatalogGrid_CatalogGrid,  true ? {
  target: "e1cc03c30"
} : 0)("row-gap:16px;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("lg");
}, "{row-gap:48px;}" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../libs/api/routes/catalog/queries/index.ts + 11 modules
var queries = __webpack_require__(83628);
// EXTERNAL MODULE: ../../libs/utils/useNextPageTrigger/index.ts + 1 modules
var useNextPageTrigger = __webpack_require__(78299);
;// CONCATENATED MODULE: ./src/views/Catalog/LandingPage/components/GroupedGrid/useGroupedGrid.ts




var useGroupedGrid = function useGroupedGrid(_ref) {
  var _groupedQueryData$dat2, _groupedQueryData$dat3, _groupedQueryData$dat4, _groupedQueryData$has;

  var filteringState = _ref.filteringState;
  var groupedQueryData = (0,queries/* useGroupedIntegrationsQuery */.yT)({
    args: [filteringState],
    options: {
      enabled: filteringState.query === ""
    }
  });
  var groupedQueryDataFlattenedPages = (0,react.useMemo)(function () {
    var _groupedQueryData$dat;

    return (_groupedQueryData$dat = groupedQueryData.data) === null || _groupedQueryData$dat === void 0 ? void 0 : _groupedQueryData$dat.pages.flatMap(function (page) {
      return page.hits;
    });
  }, [(_groupedQueryData$dat2 = groupedQueryData.data) === null || _groupedQueryData$dat2 === void 0 ? void 0 : _groupedQueryData$dat2.pages]);
  return {
    hasNextPage: groupedQueryData.hasNextPage,
    isEmpty: !groupedQueryData.isLoading && !groupedQueryData.hasNextPage && groupedQueryDataFlattenedPages && (groupedQueryDataFlattenedPages === null || groupedQueryDataFlattenedPages === void 0 ? void 0 : groupedQueryDataFlattenedPages.length) === 0,
    nextPageTrigger: (0,useNextPageTrigger/* default */.Z)({
      isLoading: groupedQueryData.isLoading,
      totalDownloadedPages: (_groupedQueryData$dat3 = (_groupedQueryData$dat4 = groupedQueryData.data) === null || _groupedQueryData$dat4 === void 0 ? void 0 : _groupedQueryData$dat4.pages.length) !== null && _groupedQueryData$dat3 !== void 0 ? _groupedQueryData$dat3 : -1,
      hasNextPage: (_groupedQueryData$has = groupedQueryData.hasNextPage) !== null && _groupedQueryData$has !== void 0 ? _groupedQueryData$has : false,
      onNextPage: function onNextPage() {
        var _groupedQueryData$fet;

        (_groupedQueryData$fet = groupedQueryData.fetchNextPage) === null || _groupedQueryData$fet === void 0 ? void 0 : _groupedQueryData$fet.call(groupedQueryData);
      },
      loadMargin: "0%"
    }),
    groupedQueryDataFlattenedPages: groupedQueryDataFlattenedPages
  };
};

/* harmony default export */ var GroupedGrid_useGroupedGrid = (useGroupedGrid);
;// CONCATENATED MODULE: ./src/views/Catalog/LandingPage/components/SearchGrid/useSearchGrid.ts




var useSearchGrid = function useSearchGrid(_ref) {
  var _categorySearchQueryD2, _allCategoriesSearchQ2, _allCategoriesSearchQ3, _categorySearchQueryD3, _categorySearchQueryD4, _categorySearchQueryD5;

  var filteringState = _ref.filteringState,
      category = _ref.category,
      query = _ref.query;
  var categorySearchQueryData = (0,queries/* useIntegrationsQuery */.B)({
    args: [{
      query: query,
      category: category === null || category === void 0 ? void 0 : category.slug,
      destination: filteringState.destination,
      source: filteringState.source
    }],
    options: {
      keepPreviousData: true,
      enabled: Boolean(query)
    }
  });
  var allCategoriesSearchQueryData = (0,queries/* useIntegrationsQuery */.B)({
    args: [{
      query: query,
      category: category === null || category === void 0 ? void 0 : category.slug,
      categoryNegation: true,
      hitsPerPage: 4,
      destination: filteringState.destination,
      source: filteringState.source
    }],
    options: {
      enabled: Boolean(category === null || category === void 0 ? void 0 : category.slug) && Boolean(query),
      keepPreviousData: true
    }
  });
  var flattenedPagesCategorySearch = (0,react.useMemo)(function () {
    var _categorySearchQueryD;

    return (_categorySearchQueryD = categorySearchQueryData.data) === null || _categorySearchQueryD === void 0 ? void 0 : _categorySearchQueryD.pages.flatMap(function (page) {
      return page.hits;
    });
  }, [(_categorySearchQueryD2 = categorySearchQueryData.data) === null || _categorySearchQueryD2 === void 0 ? void 0 : _categorySearchQueryD2.pages]);
  var flattenedPagesAllCategoriesSearch = (0,react.useMemo)(function () {
    var _allCategoriesSearchQ;

    return (_allCategoriesSearchQ = allCategoriesSearchQueryData.data) === null || _allCategoriesSearchQ === void 0 ? void 0 : _allCategoriesSearchQ.pages.flatMap(function (page) {
      return page.hits;
    });
  }, [(_allCategoriesSearchQ2 = allCategoriesSearchQueryData.data) === null || _allCategoriesSearchQ2 === void 0 ? void 0 : _allCategoriesSearchQ2.pages]);
  var emptyHits = (_allCategoriesSearchQ3 = allCategoriesSearchQueryData.data) === null || _allCategoriesSearchQ3 === void 0 ? void 0 : _allCategoriesSearchQ3.pages[0].nbHits;
  var hasCategoryEntries = flattenedPagesCategorySearch ? flattenedPagesCategorySearch.length > 0 : false;
  return {
    hasNextPage: categorySearchQueryData.hasNextPage,
    isEmpty: !hasCategoryEntries,
    flattenedPagesCategorySearch: flattenedPagesCategorySearch,
    flattenedPagesAllCategoriesSearch: flattenedPagesAllCategoriesSearch,
    nextPageTrigger: (0,useNextPageTrigger/* default */.Z)({
      isLoading: categorySearchQueryData.isLoading,
      totalDownloadedPages: (_categorySearchQueryD3 = (_categorySearchQueryD4 = categorySearchQueryData.data) === null || _categorySearchQueryD4 === void 0 ? void 0 : _categorySearchQueryD4.pages.length) !== null && _categorySearchQueryD3 !== void 0 ? _categorySearchQueryD3 : -1,
      hasNextPage: (_categorySearchQueryD5 = categorySearchQueryData.hasNextPage) !== null && _categorySearchQueryD5 !== void 0 ? _categorySearchQueryD5 : false,
      onNextPage: function onNextPage() {
        var _categorySearchQueryD6;

        (_categorySearchQueryD6 = categorySearchQueryData.fetchNextPage) === null || _categorySearchQueryD6 === void 0 ? void 0 : _categorySearchQueryD6.call(categorySearchQueryData);
      },
      loadMargin: "0%"
    }),
    emptyHits: emptyHits
  };
};

/* harmony default export */ var SearchGrid_useSearchGrid = (useSearchGrid);
;// CONCATENATED MODULE: ./src/views/Catalog/LandingPage/components/CategoryGrid/useCategoryGrid.ts


function useCategoryGrid_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function useCategoryGrid_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? useCategoryGrid_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : useCategoryGrid_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var useCategoryGrid = function useCategoryGrid(_ref) {
  var _categoryQueryData$da2, _categoryQueryData$da3, _categoryQueryData$da4, _categoryQueryData$ha;

  var filteringState = _ref.filteringState,
      category = _ref.category,
      query = _ref.query;
  var categoryQueryData = (0,queries/* useIntegrationsQuery */.B)({
    args: [useCategoryGrid_objectSpread(useCategoryGrid_objectSpread({
      category: category === null || category === void 0 ? void 0 : category.slug
    }, filteringState), {}, {
      query: query
    })],
    options: {
      enabled: Boolean(category)
    }
  });
  var categoryQueryDataFlattenedPages = (0,react.useMemo)(function () {
    var _categoryQueryData$da;

    return (_categoryQueryData$da = categoryQueryData.data) === null || _categoryQueryData$da === void 0 ? void 0 : _categoryQueryData$da.pages.flatMap(function (page) {
      return page.hits;
    });
  }, [(_categoryQueryData$da2 = categoryQueryData.data) === null || _categoryQueryData$da2 === void 0 ? void 0 : _categoryQueryData$da2.pages]);
  return {
    hasNextPage: categoryQueryData.hasNextPage,
    isEmpty: !categoryQueryData.isLoading && !categoryQueryData.hasNextPage && categoryQueryDataFlattenedPages && (categoryQueryDataFlattenedPages === null || categoryQueryDataFlattenedPages === void 0 ? void 0 : categoryQueryDataFlattenedPages.length) === 0,
    nextPageTrigger: (0,useNextPageTrigger/* default */.Z)({
      isLoading: categoryQueryData.isLoading,
      totalDownloadedPages: (_categoryQueryData$da3 = (_categoryQueryData$da4 = categoryQueryData.data) === null || _categoryQueryData$da4 === void 0 ? void 0 : _categoryQueryData$da4.pages.length) !== null && _categoryQueryData$da3 !== void 0 ? _categoryQueryData$da3 : -1,
      hasNextPage: (_categoryQueryData$ha = categoryQueryData.hasNextPage) !== null && _categoryQueryData$ha !== void 0 ? _categoryQueryData$ha : false,
      onNextPage: function onNextPage() {
        var _categoryQueryData$fe;

        (_categoryQueryData$fe = categoryQueryData.fetchNextPage) === null || _categoryQueryData$fe === void 0 ? void 0 : _categoryQueryData$fe.call(categoryQueryData);
      },
      loadMargin: "0%"
    }),
    categoryQueryDataFlattenedPages: categoryQueryDataFlattenedPages
  };
};

/* harmony default export */ var CategoryGrid_useCategoryGrid = (useCategoryGrid);
// EXTERNAL MODULE: ./src/views/Catalog/LandingPage/assets/OgCatalog.png
var OgCatalog = __webpack_require__(63978);
var OgCatalog_default = /*#__PURE__*/__webpack_require__.n(OgCatalog);
;// CONCATENATED MODULE: ./src/views/Catalog/LandingPage/Catalog.tsx



function Catalog_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Catalog_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Catalog_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Catalog_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function Catalog_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }



























var typeReducer = function typeReducer(state, action) {
  switch (action.type) {
    case "source":
      return Catalog_objectSpread(Catalog_objectSpread({}, state), {}, {
        source: !state.source
      });

    case "destination":
      return Catalog_objectSpread(Catalog_objectSpread({}, state), {}, {
        destination: !state.destination
      });

    default:
      return state;
  }
};

var useIsChangingCategoryRoute = function useIsChangingCategoryRoute() {
  var _useState = (0,react.useState)(false),
      isChangingCategoryRoute = _useState[0],
      setIsChangingCategoryRoute = _useState[1];

  var router = (0,next_router.useRouter)();
  (0,react.useEffect)(function () {
    var handleRouteChange = function handleRouteChange(url) {
      if (url.match(/^\/catalog/)) {
        setIsChangingCategoryRoute(true);
      }
    };

    var handleRouteChangeFinalized = function handleRouteChangeFinalized() {
      setIsChangingCategoryRoute(false);
    };

    router.events.on("routeChangeStart", handleRouteChange);
    router.events.on("routeChangeComplete", handleRouteChangeFinalized);
    router.events.on("routeChangeError", handleRouteChangeFinalized); // If the component is unmounted, unsubscribe
    // from the event with the `off` method:

    return function () {
      router.events.off("routeChangeStart", handleRouteChange);
      router.events.off("routeChangeComplete", handleRouteChangeFinalized);
      router.events.off("routeChangeError", handleRouteChangeFinalized);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return isChangingCategoryRoute;
};

var CatalogView = function CatalogView(_ref2) {
  var categoryId = _ref2.categoryId,
      initialFilteringState = _ref2.filteringState,
      categories = _ref2.categories;
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();

  var _useState2 = (0,react.useState)(""),
      query = _useState2[0],
      setQuery = _useState2[1];

  var heroRef = (0,react.useRef)(null);

  var _useState3 = (0,react.useState)(false),
      isLoadingCategoryRouteData = _useState3[0],
      setIsLoadingCategoryRouteData = _useState3[1];

  var isSearching = Boolean(query.trim());
  var normalizedCategoryId = categoryId === "all" ? null : categoryId;
  var category = categories.find(function (c) {
    return c.slug === categoryId;
  });
  var isInCategory = normalizedCategoryId !== null && normalizedCategoryId !== undefined;

  var _useReducer = (0,react.useReducer)(typeReducer, initialFilteringState),
      filteringState = _useReducer[0],
      dispatch = _useReducer[1];

  var isChangingCategoryRoute = useIsChangingCategoryRoute();
  (0,react.useEffect)(function () {
    if (query.length) {
      (0,scripts/* trackCatalogSearch */.X_)(query);
    }
  }, [query]);
  var property = (0,react.useMemo)(function () {
    if (!isInCategory && !isSearching) {
      return "GroupedGrid";
    }

    if (isInCategory && category && !isSearching) {
      return "CategoryGrid";
    }

    if (isSearching) {
      return "SearchGrid";
    }
  }, [isInCategory, isSearching, category]);
  var groupedGrid = GroupedGrid_useGroupedGrid({
    filteringState: filteringState
  });
  var searchGrid = SearchGrid_useSearchGrid({
    filteringState: filteringState,
    category: category,
    query: query
  });
  var categoryGrid = CategoryGrid_useCategoryGrid({
    filteringState: filteringState,
    category: category,
    query: query
  });
  var ongoingFetches = (0,useIsFetching/* useIsFetching */.y)(["catalog"]);
  var isFetching = ongoingFetches > 0;
  var showLoadingState = isFetching || isLoadingCategoryRouteData || isChangingCategoryRoute;
  var showFooter = (0,react.useMemo)(function () {
    if (!isInCategory && !isSearching) {
      return Boolean(!groupedGrid.hasNextPage);
    }

    if (isInCategory && category && !isSearching) {
      return Boolean(!categoryGrid.hasNextPage);
    }

    if (isSearching) {
      return Boolean(!searchGrid.hasNextPage);
    }

    return false;
  }, [isInCategory, isSearching, category, categoryGrid, groupedGrid, searchGrid]);
  var router = (0,next_router.useRouter)();

  var scrollToTop = function scrollToTop() {
    var _heroRef$current;

    var positionTop = heroRef.current ? (_heroRef$current = heroRef.current) === null || _heroRef$current === void 0 ? void 0 : _heroRef$current.getBoundingClientRect().height : 0; // 96 it is a navbar height

    window.scrollTo({
      top: positionTop - 96,
      behavior: "smooth"
    });
  };

  var onCategoryChange = (0,react.useCallback)(function (value) {
    setIsLoadingCategoryRouteData(true);
    scrollToTop();

    if (value === "all") {
      router.push("/catalog/", undefined, {
        scroll: false
      }).then(function () {
        setIsLoadingCategoryRouteData(false);
      });
    } else {
      router.push("/catalog/".concat(value), undefined, {
        scroll: false
      }).then(function () {
        setIsLoadingCategoryRouteData(false);
      });
    }
  }, [router]);
  var pageDescription = "One API unlocks ".concat("450", "+ tools. All the best apps for analytics, advertising, chat, data-warehousing and more. Twilio Segment\u2019s catalog has every tool you need to grow.");
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: "twilioLight",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(layout/* default */.Z, {
      pageTitle: "Integration Catalog | Twilio Segment",
      pageDescription: pageDescription,
      pageOG: (OgCatalog_default()),
      canonicalUrl: "https://segment.com/catalog/",
      themeColor: theme.palette.twilio.gray[10],
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Main, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Hero_Hero, {
          ref: heroRef,
          query: query,
          onQueryChange: setQuery,
          isFetching: isFetching
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Content, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Sidebar, {
            bottomSpace: Boolean(showFooter),
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FiltersAside, {
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MobileCategoriesSlot, {
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FilterLabel, {
                  children: "Filter by"
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileCategoriesList_MobileCategoriesList, {
                  categoryId: categoryId,
                  categories: categories,
                  onCategoryChange: onCategoryChange
                })]
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TypesSlot, {
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DesktopFilterTitle, {
                  children: "Types"
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TypeCheckbox, {
                  checked: filteringState.source,
                  label: "Sources",
                  name: "sources-checkbox",
                  onChange: function onChange() {
                    return dispatch({
                      type: "source"
                    });
                  }
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TypeCheckbox, {
                  checked: filteringState.destination,
                  label: "Destinations",
                  name: "destinations-checkbox",
                  onChange: function onChange() {
                    return dispatch({
                      type: "destination"
                    });
                  }
                })]
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DesktopCategoriesSlot, {
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DesktopCategoriesList_DesktopCategoriesList, {
                  categoryId: categoryId,
                  categories: categories,
                  onCategoryChange: onCategoryChange
                })
              })]
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileDivider, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ScrollToHash, {
            id: "grid",
            children: [property === "GroupedGrid" && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GroupedGrid_GroupedGrid, {
              onCategoryChange: onCategoryChange,
              nextPageTrigger: groupedGrid.nextPageTrigger,
              flattenedPages: groupedGrid.groupedQueryDataFlattenedPages,
              isEmpty: groupedGrid.isEmpty,
              destination: filteringState.destination,
              source: filteringState.source,
              isLoading: showLoadingState
            }), property === "CategoryGrid" && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CategoryGrid_CategoryGrid, {
              category: category,
              flattenedPages: categoryGrid.categoryQueryDataFlattenedPages,
              nextPageTrigger: categoryGrid.nextPageTrigger,
              isEmpty: categoryGrid.isEmpty,
              isLoading: showLoadingState
            }), property === "SearchGrid" && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchGrid_SearchGrid, {
              category: category,
              query: query,
              onCategoryChange: onCategoryChange,
              isEmpty: searchGrid.isEmpty,
              flattenedPagesCategorySearch: searchGrid.flattenedPagesCategorySearch,
              flattenedPagesAllCategoriesSearch: searchGrid.flattenedPagesAllCategoriesSearch,
              nextPageTrigger: searchGrid.nextPageTrigger,
              emptyHits: searchGrid.emptyHits,
              isLoading: showLoadingState
            })]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_LoadingOverlay, {
            "data-testid": "loading-overlay",
            "aria-busy": showLoadingState,
            "data-loading": showLoadingState,
            isFetching: showLoadingState
          })]
        }), showFooter && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GettingStarted["default"], {})]
      })]
    }), showFooter && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer/* default */.Z, {})]
  });
};

var ScrollToHash = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1rxv3bd12"
} : 0)( true ? {
  name: "1bqgayv",
  styles: "padding-top:96px;margin-top:-96px"
} : 0);

var Main = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("main",  true ? {
  target: "e1rxv3bd11"
} : 0)("background-color:", function (_ref3) {
  var theme = _ref3.theme;
  return theme.palette.twilio.gray[10];
}, ";" + ( true ? "" : 0));

var DesktopFilterTitle = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("h4",  true ? {
  target: "e1rxv3bd10"
} : 0)(function (_ref4) {
  var theme = _ref4.theme;
  return theme.typography.buttonLarge;
}, " display:none;", function (_ref5) {
  var theme = _ref5.theme;
  return theme.breakpoints.up("lg");
}, "{display:block;}" + ( true ? "" : 0));

var FilterLabel = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("p",  true ? {
  target: "e1rxv3bd9"
} : 0)(function (_ref6) {
  var theme = _ref6.theme;
  return theme.typography.textBoldSmall;
}, " ", function (_ref7) {
  var theme = _ref7.theme;
  return theme.breakpoints.down("sm");
}, "{display:none;}" + ( true ? "" : 0));

var Catalog_ref =  true ? {
  name: "1su8pto",
  styles: "padding-bottom:200px"
} : 0;

var Sidebar = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1rxv3bd8"
} : 0)(function (_ref8) {
  var theme = _ref8.theme;
  return theme.breakpoints.up("lg");
}, "{", function (_ref9) {
  var bottomSpace = _ref9.bottomSpace;
  return bottomSpace && Catalog_ref;
}, ";}position:relative;" + ( true ? "" : 0));

var TypeCheckbox = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CheckboxField/* default */.Z,  true ? {
  target: "e1rxv3bd7"
} : 0)( true ? {
  name: "4zleql",
  styles: "display:block"
} : 0);

var FiltersAside = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("aside",  true ? {
  target: "e1rxv3bd6"
} : 0)("top:0;position:sticky;display:grid;gap:24px;grid-template-columns:auto;align-items:center;align-content:flex-start;padding:20px 24px;", function (_ref10) {
  var theme = _ref10.theme;
  return theme.breakpoints.up("sm");
}, "{grid-template-columns:auto auto;padding:40px;gap:56px;}", function (_ref11) {
  var theme = _ref11.theme;
  return theme.breakpoints.up("lg");
}, "{grid-template-columns:auto;align-items:initial;padding:120px 0 0 0;margin-top:-40px;}" + ( true ? "" : 0));

var MobileDivider = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Divider/* default */.Z,  true ? {
  target: "e1rxv3bd5"
} : 0)(function (_ref12) {
  var theme = _ref12.theme;
  return theme.breakpoints.up("lg");
}, "{display:none;}" + ( true ? "" : 0));

var FiltersSlot = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1rxv3bd4"
} : 0)( true ? {
  name: "2lune6",
  styles: "display:grid;gap:24px"
} : 0);

var TypesSlot = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(FiltersSlot,  true ? {
  target: "e1rxv3bd3"
} : 0)("display:flex;", function (_ref13) {
  var theme = _ref13.theme;
  return theme.breakpoints.up("sm");
}, "{grid-auto-flow:column;display:grid;}", function (_ref14) {
  var theme = _ref14.theme;
  return theme.breakpoints.up("lg");
}, "{grid-auto-flow:row;}" + ( true ? "" : 0));

var MobileCategoriesSlot = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(FiltersSlot,  true ? {
  target: "e1rxv3bd2"
} : 0)("display:grid;grid-auto-flow:column;gap:24px;justify-content:stretch;align-items:center;", function (_ref15) {
  var theme = _ref15.theme;
  return theme.breakpoints.up("lg");
}, "{display:none;}" + ( true ? "" : 0));

var DesktopCategoriesSlot = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(FiltersSlot,  true ? {
  target: "e1rxv3bd1"
} : 0)("display:none;", function (_ref16) {
  var theme = _ref16.theme;
  return theme.breakpoints.up("lg");
}, "{display:grid;}" + ( true ? "" : 0));

var Content = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1rxv3bd0"
} : 0)("position:relative;width:100%;max-width:1520px;margin:0 auto;display:grid;grid-template-columns:auto;", function (_ref17) {
  var theme = _ref17.theme;
  return theme.breakpoints.up("lg");
}, "{padding:0 40px;gap:60px;grid-template-columns:256px minmax(auto, 1054px);}" + ( true ? "" : 0));

/* harmony default export */ var LandingPage_Catalog = (CatalogView);
// EXTERNAL MODULE: ../../libs/api/algolia/client.ts
var client = __webpack_require__(2017);
// EXTERNAL MODULE: ../../libs/contexts/catalogIndex.ts
var catalogIndex = __webpack_require__(97946);
// EXTERNAL MODULE: ../../libs/contexts/staticSiteBackend.ts
var contexts_staticSiteBackend = __webpack_require__(86708);
;// CONCATENATED MODULE: ./src/pages/catalog/index.tsx






var __N_SSG = true;

var Catalog = function Catalog(_ref) {
  var filteringState = _ref.filteringState,
      categoryId = _ref.categoryId,
      categories = _ref.categories;
  var catalogClient = (0,react.useMemo)(function () {
    return (0,client/* createClient */.e)();
  }, []);
  var staticSiteBackend = (0,react.useMemo)(function () {
    return (0,contexts_staticSiteBackend/* createStaticSiteBackend */.I4)();
  }, []);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(contexts_staticSiteBackend/* StaticSiteBackendProvider */.D1, {
    value: staticSiteBackend,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(catalogIndex/* CatalogClientProvider */.sR, {
      value: catalogClient,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LandingPage_Catalog, {
        filteringState: filteringState,
        categoryId: categoryId,
        categories: categories
      })
    })
  });
};

/* harmony default export */ var catalog = (Catalog);

/***/ }),

/***/ 40620:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20406);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28526);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _segment_matcha_recipes_IntegrationCard__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97536);
/* harmony import */ var _segment_tracking_scripts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17397);
/* harmony import */ var _segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(43848);
/* harmony import */ var _segment_contexts_page__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17782);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52903);









var EMPTY_QUERY_MESSAGE = "No search term specified";

var IntegrationCardTemplate = function IntegrationCardTemplate(_ref) {
  var _integration$logo, _integration$logo2, _integration$logo$src, _integration$logo3, _integration$categori, _integration$categori2, _integration$categori3;

  var integration = _ref.integration,
      isInCategoryGrid = _ref.isInCategoryGrid,
      query = _ref.query;
  var pageConfig = (0,_segment_contexts_page__WEBPACK_IMPORTED_MODULE_4__/* .usePageConfig */ .Gm)();
  var onClickHandler = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)( /*#__PURE__*/(0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)( /*#__PURE__*/_workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
    var _integration$slug;

    return _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0,_segment_tracking_scripts__WEBPACK_IMPORTED_MODULE_3__/* .trackCatalogCardClick */ .tR)({
              searchTerm: query !== null && query !== void 0 ? query : EMPTY_QUERY_MESSAGE,
              catalogItem: integration === null || integration === void 0 ? void 0 : (_integration$slug = integration.slug) === null || _integration$slug === void 0 ? void 0 : _integration$slug.replace(/\//g, "")
            });

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [integration, query]);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_segment_matcha_recipes_IntegrationCard__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
    href: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("/catalog/integrations/".concat(integration.type).concat(integration.slug), pageConfig),
    onClick: onClickHandler,
    children: [integration.beta && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_segment_matcha_recipes_IntegrationCard__WEBPACK_IMPORTED_MODULE_2__/* .Badge */ .Ct, {
      children: "Beta"
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_segment_matcha_recipes_IntegrationCard__WEBPACK_IMPORTED_MODULE_2__/* .Row */ .X2, {
      centered: true,
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_segment_matcha_recipes_IntegrationCard__WEBPACK_IMPORTED_MODULE_2__/* .LogoWrapper */ .K7, {
        children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_segment_matcha_recipes_IntegrationCard__WEBPACK_IMPORTED_MODULE_2__/* .Logo */ .TR, {
          width: (_integration$logo = integration.logo) === null || _integration$logo === void 0 ? void 0 : _integration$logo.width,
          height: (_integration$logo2 = integration.logo) === null || _integration$logo2 === void 0 ? void 0 : _integration$logo2.height,
          src: (_integration$logo$src = (_integration$logo3 = integration.logo) === null || _integration$logo3 === void 0 ? void 0 : _integration$logo3.src) !== null && _integration$logo$src !== void 0 ? _integration$logo$src : "",
          alt: "integration logo"
        })
      })
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_segment_matcha_recipes_IntegrationCard__WEBPACK_IMPORTED_MODULE_2__/* .Row */ .X2, {
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_segment_matcha_recipes_IntegrationCard__WEBPACK_IMPORTED_MODULE_2__/* .Name */ .VG, {
        children: integration.name
      }), !isInCategoryGrid && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_segment_matcha_recipes_IntegrationCard__WEBPACK_IMPORTED_MODULE_2__/* .Description */ .dk, {
        children: (_integration$categori = integration.categories) === null || _integration$categori === void 0 ? void 0 : (_integration$categori2 = _integration$categori[0]) === null || _integration$categori2 === void 0 ? void 0 : (_integration$categori3 = _integration$categori2.category) === null || _integration$categori3 === void 0 ? void 0 : _integration$categori3.name
      })]
    })]
  }, integration.objectID);
};

/* harmony default export */ __webpack_exports__["Z"] = (IntegrationCardTemplate);

/***/ }),

/***/ 83628:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "yT": function() { return /* reexport */ useGroupedIntegrationsQuery; },
  "B": function() { return /* reexport */ useIntegrationsQuery; },
  "UF": function() { return /* reexport */ useSimilarIntegrationsQuery; },
  "aV": function() { return /* reexport */ useSingleIntegrationQuery; }
});

// UNUSED EXPORTS: attributesToFetch, createAllCategoriesQuery, createAllIntegrationsQuery, createGroupedIntegrationsQuery, createIntegrationsQuery, createNonEmptyCategoriesQuery, createSimilarIntegrationsQuery, createSingleIntegrationQuery, fetchIntegrations, fetchRandomSimilarIntegrations, groupIntegrations, similarIntegrationsAttributesToFetch, useAllCategoriesQuery, useAllIntegrationsQuery, useNonEmptyIntegrationsQuery

// EXTERNAL MODULE: ../../libs/utils/createQueryHook/createQueryHook.ts
var createQueryHook = __webpack_require__(74048);
// EXTERNAL MODULE: ../../libs/contexts/staticSiteBackend.ts
var contexts_staticSiteBackend = __webpack_require__(86708);
// EXTERNAL MODULE: ../../node_modules/lodash/sortBy.js
var sortBy = __webpack_require__(829);
var sortBy_default = /*#__PURE__*/__webpack_require__.n(sortBy);
;// CONCATENATED MODULE: ../../libs/api/staticSiteBackend/catalog.ts

var fetchAllCategories = function fetchAllCategories(client) {
  return client.get("/content/entries/category").then(function (value) {
    return sortBy_default()(value, function (item) {
      return item.name;
    });
  });
};
;// CONCATENATED MODULE: ../../libs/api/routes/catalog/queries/allCategoriesQuery.ts



var createAllCategoriesQuery = function createAllCategoriesQuery(client) {
  return [["catalog/allCategoriesQuery"], function () {
    return fetchAllCategories(client);
  }];
};
var useAllCategoriesQuery = (0,createQueryHook/* default */.Z)(createAllCategoriesQuery, contexts_staticSiteBackend/* useStaticSiteBackend */.gR, {
  staleTime: Infinity
});
;// CONCATENATED MODULE: ../../libs/api/staticSiteBackend/integration.ts

var fetchAllIntegrations = function fetchAllIntegrations(client) {
  return client.get("/content/entries/integrations").then(function (value) {
    // If the integration is in Private Beta, we want to filter it out of the response.
    var filteredValue = value.filter(function (value) {
      return !value.privateBeta;
    });
    return sortBy_default()(filteredValue, function (item) {
      return item.name;
    });
  });
};
var fetchIntegration = function fetchIntegration(client, slug) {
  return client.get("/content/entries/integrations?url=".concat(slug)).then(function (value) {
    // If the integration is in Private Beta, we do not want to generate a static page for the integration.
    if (value.privateBeta) {
      return;
    }

    return value;
  });
};
;// CONCATENATED MODULE: ../../libs/api/routes/catalog/queries/allIntegrationsQuery.ts



var createAllIntegrationsQuery = function createAllIntegrationsQuery(client) {
  return [["catalog", "allIntegrationsQuery"], function () {
    return fetchAllIntegrations(client);
  }];
};
var useAllIntegrationsQuery = (0,createQueryHook/* default */.Z)(createAllIntegrationsQuery, contexts_staticSiteBackend/* useStaticSiteBackend */.gR, {
  staleTime: Infinity
});
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(20406);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(28526);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ../../libs/utils/fsCache/index.ts
var fsCache = __webpack_require__(96904);
// EXTERNAL MODULE: ../../libs/contexts/catalogIndex.ts
var contexts_catalogIndex = __webpack_require__(97946);
;// CONCATENATED MODULE: ../../libs/api/routes/catalog/queries/allNonEmptyCategories.ts
/* provided dependency */ var process = __webpack_require__(34406);







var keys = ["catalog", "nonEmptyCategoriesQuery"];
var createNonEmptyCategoriesQuery = function createNonEmptyCategoriesQuery(_ref) {
  var catalogIndex = _ref.catalogIndex,
      staticSiteBackend = _ref.staticSiteBackend;
  return [keys, /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
    var enabled, algoliaCachedSearch, facetsRequest, categoriesRequest, _yield$facetsRequest, facets, categories, integrationsCountPerCategory, categoriesWithAnyIntegrations;

    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            enabled = Boolean(process.env.ENABLE_FS_CACHE);
            _context.next = 3;
            return (0,fsCache/* createFsCacheProxy */.c)(keys, catalogIndex.search, {
              enabled: enabled
            });

          case 3:
            algoliaCachedSearch = _context.sent;
            facetsRequest = algoliaCachedSearch("", {
              responseFields: ["facets"],
              facets: ["categories.category.slug"],
              maxValuesPerFacet: 1000
            });
            categoriesRequest = fetchAllCategories(staticSiteBackend);
            _context.next = 8;
            return facetsRequest;

          case 8:
            _yield$facetsRequest = _context.sent;
            facets = _yield$facetsRequest.facets;
            _context.next = 12;
            return categoriesRequest;

          case 12:
            categories = _context.sent;
            integrationsCountPerCategory = facets === null || facets === void 0 ? void 0 : facets["categories.category.slug"];
            categoriesWithAnyIntegrations = categories.filter(function (c) {
              return integrationsCountPerCategory && integrationsCountPerCategory[c.url];
            });
            return _context.abrupt("return", categoriesWithAnyIntegrations.map(function (c) {
              return {
                name: c.name,
                slug: c.url
              };
            }));

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }))];
};
var useNonEmptyIntegrationsQuery = (0,createQueryHook/* default */.Z)(createNonEmptyCategoriesQuery, function () {
  var catalogIndex = (0,contexts_catalogIndex/* useCatalogIndex */.TO)();
  var staticSiteBackend = (0,contexts_staticSiteBackend/* useStaticSiteBackend */.gR)();
  return {
    catalogIndex: catalogIndex,
    staticSiteBackend: staticSiteBackend
  };
}, {
  staleTime: Infinity
});
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(12741);
;// CONCATENATED MODULE: ../../libs/api/routes/catalog/queries/common.ts
/* provided dependency */ var common_process = __webpack_require__(34406);




var attributesToFetch = ["contentType", "slug", "name", "logo", "categories", "type", "beta"];
var DESTINATION_FILTER = "type:destination";
var SOURCE_FILTER = "type:source";
var INTEGRATIONS_CONTENT_TYPE = "contentType:integrations";
var fetchIntegrations = /*#__PURE__*/function () {
  var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(_ref) {
    var query, catalogIndex, pageParam, category, _ref$distinct, distinct, hitsPerPage, source, destination, _ref$categoryNegation, categoryNegation, extFilters, cacheKey, enabled, algoliaCachedSearch, categoryFilters, typeFilters, filters;

    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            query = _ref.query, catalogIndex = _ref.catalogIndex, pageParam = _ref.pageParam, category = _ref.category, _ref$distinct = _ref.distinct, distinct = _ref$distinct === void 0 ? 0 : _ref$distinct, hitsPerPage = _ref.hitsPerPage, source = _ref.source, destination = _ref.destination, _ref$categoryNegation = _ref.categoryNegation, categoryNegation = _ref$categoryNegation === void 0 ? false : _ref$categoryNegation, extFilters = _ref.filters, cacheKey = _ref.cacheKey;
            enabled = Boolean(common_process.env.ENABLE_FS_CACHE);
            _context.next = 4;
            return (0,fsCache/* createFsCacheProxy */.c)(["catalog-fetchIntegrations"].concat((0,toConsumableArray/* default */.Z)(cacheKey ? cacheKey : [query, pageParam !== null && pageParam !== void 0 ? pageParam : null, category !== null && category !== void 0 ? category : null, distinct !== null && distinct !== void 0 ? distinct : null, hitsPerPage !== null && hitsPerPage !== void 0 ? hitsPerPage : null, source !== null && source !== void 0 ? source : null, destination !== null && destination !== void 0 ? destination : null, categoryNegation !== null && categoryNegation !== void 0 ? categoryNegation : null, extFilters !== null && extFilters !== void 0 ? extFilters : null])), function () {
              return catalogIndex.search.apply(catalogIndex, arguments);
            }, {
              enabled: enabled
            });

          case 4:
            algoliaCachedSearch = _context.sent;
            categoryFilters = typeof category === "string" ? (categoryNegation ? "NOT " : "") + "categories.category.slug:".concat(category) : undefined;
            typeFilters = [];
            if (destination) typeFilters.push(DESTINATION_FILTER);
            if (source) typeFilters.push(SOURCE_FILTER);
            if (!source && !destination) typeFilters.push("NOT ".concat(DESTINATION_FILTER, " AND NOT ").concat(SOURCE_FILTER));
            filters = [categoryFilters, extFilters, "(".concat(typeFilters.join(" OR "), ")"), INTEGRATIONS_CONTENT_TYPE].filter(function (filter) {
              return filter && filter !== "()";
            }).join(" AND ");
            return _context.abrupt("return", algoliaCachedSearch(query, {
              attributesToRetrieve: ["-*"].concat(attributesToFetch),
              distinct: distinct,
              page: pageParam !== null && pageParam !== void 0 ? pageParam : 0,
              hitsPerPage: hitsPerPage,
              filters: filters
            }));

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchIntegrations(_x) {
    return _ref2.apply(this, arguments);
  };
}();
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../libs/utils/createInfinityQueryHook/createInfinityQueryHook.ts
var createInfinityQueryHook = __webpack_require__(99338);
;// CONCATENATED MODULE: ../../libs/api/routes/catalog/queries/utils.ts
var groupIntegrations = function groupIntegrations(acc, integration) {
  if (integration._distinctSeqID === 0 || integration._distinctSeqID === undefined) {
    var _integration$categori, _integration$categori2;

    var category = (_integration$categori = integration.categories) === null || _integration$categori === void 0 ? void 0 : (_integration$categori2 = _integration$categori[0]) === null || _integration$categori2 === void 0 ? void 0 : _integration$categori2.category;

    if (category && category.name && category.slug) {
      acc.push({
        category: {
          name: category.name,
          slug: category.slug
        },
        integrations: [integration]
      });
    } else {
      acc.push({
        integrations: [integration]
      });
    }
  } else if (acc.length > 0) {
    acc[acc.length - 1].integrations.push(integration);
  } else {
    throw new Error("Invalid algolia response. Hits sequence isn't starting with _distinctSeqID=0");
  }

  return acc;
};
;// CONCATENATED MODULE: ../../libs/api/routes/catalog/queries/groupedIntegrationsQuery.ts



var _excluded = ["hits"];


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var createGroupedIntegrationsQuery = function createGroupedIntegrationsQuery(catalogIndex) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$destination = _ref.destination,
      destination = _ref$destination === void 0 ? true : _ref$destination,
      _ref$source = _ref.source,
      source = _ref$source === void 0 ? true : _ref$source;

  return [["catalog", "groupedIntegrationsQuery", destination, source], /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(_ref2) {
      var pageParam, _yield$fetchIntegrati, hits, rest, groups;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              pageParam = _ref2.pageParam;
              _context.next = 3;
              return fetchIntegrations({
                catalogIndex: catalogIndex,
                query: "",
                category: null,
                destination: destination,
                pageParam: pageParam,
                source: source,
                distinct: 8,
                hitsPerPage: 4
              });

            case 3:
              _yield$fetchIntegrati = _context.sent;
              hits = _yield$fetchIntegrati.hits;
              rest = (0,objectWithoutProperties/* default */.Z)(_yield$fetchIntegrati, _excluded);
              groups = hits.reduce(groupIntegrations, []);
              return _context.abrupt("return", _objectSpread({
                hits: groups
              }, rest));

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }()];
};
var useGroupedIntegrationsQuery = (0,createInfinityQueryHook/* default */.Z)(createGroupedIntegrationsQuery, contexts_catalogIndex/* useCatalogIndex */.TO, {
  staleTime: Infinity,
  getPreviousPageParam: function getPreviousPageParam(p) {
    var _p$page;

    var page = (_p$page = p.page) !== null && _p$page !== void 0 ? _p$page : 0;
    var prevPage = page - 1;

    if (prevPage < 0) {
      return;
    }

    return prevPage;
  },
  getNextPageParam: function getNextPageParam(p) {
    var _p$page2;

    var page = (_p$page2 = p.page) !== null && _p$page2 !== void 0 ? _p$page2 : 0;
    var nextPage = page + 1;

    if (nextPage >= p.nbPages) {
      return;
    }

    return nextPage;
  }
});
;// CONCATENATED MODULE: ../../libs/api/routes/catalog/queries/integrationsQuery.ts



var createIntegrationsQuery = function createIntegrationsQuery(_ref, _ref2) {
  var catalogIndex = _ref.catalogIndex,
      catalogSearchIndex = _ref.catalogSearchIndex;
  var query = _ref2.query,
      _ref2$category = _ref2.category,
      category = _ref2$category === void 0 ? null : _ref2$category,
      _ref2$destination = _ref2.destination,
      destination = _ref2$destination === void 0 ? true : _ref2$destination,
      _ref2$source = _ref2.source,
      source = _ref2$source === void 0 ? true : _ref2$source,
      _ref2$categoryNegatio = _ref2.categoryNegation,
      categoryNegation = _ref2$categoryNegatio === void 0 ? false : _ref2$categoryNegatio,
      _ref2$hitsPerPage = _ref2.hitsPerPage,
      hitsPerPage = _ref2$hitsPerPage === void 0 ? 20 : _ref2$hitsPerPage,
      filters = _ref2.filters;
  return [["catalog", "integrationsQuery", query, category, destination, source, categoryNegation, hitsPerPage], function (_ref3) {
    var pageParam = _ref3.pageParam;
    return fetchIntegrations({
      query: query,
      catalogIndex: query === "" ? catalogIndex : catalogSearchIndex,
      category: category,
      destination: destination,
      pageParam: pageParam,
      source: source,
      categoryNegation: categoryNegation,
      hitsPerPage: hitsPerPage,
      filters: filters
    });
  }];
};
var useIntegrationsQuery = (0,createInfinityQueryHook/* default */.Z)(createIntegrationsQuery, function () {
  var catalogIndex = (0,contexts_catalogIndex/* useCatalogAlphaIndex */.jH)();
  var catalogSearchIndex = (0,contexts_catalogIndex/* useCatalogSearchIndex */.Nv)();
  return {
    catalogIndex: catalogIndex,
    catalogSearchIndex: catalogSearchIndex
  };
}, {
  staleTime: Infinity,
  getPreviousPageParam: function getPreviousPageParam(p) {
    var _p$page;

    var page = (_p$page = p.page) !== null && _p$page !== void 0 ? _p$page : 0;
    var prevPage = page - 1;

    if (prevPage < 0) {
      return;
    }

    return prevPage;
  },
  getNextPageParam: function getNextPageParam(p) {
    var _p$page2;

    var page = (_p$page2 = p.page) !== null && _p$page2 !== void 0 ? _p$page2 : 0;
    var nextPage = page + 1;

    if (nextPage >= p.nbPages) {
      return;
    }

    return nextPage;
  }
});
;// CONCATENATED MODULE: ../../libs/api/routes/catalog/queries/singleIntegrationQuery.ts



var createSingleIntegrationQuery = function createSingleIntegrationQuery(client, slug) {
  return [["catalog/singleIntegrationQuery", slug], function () {
    return fetchIntegration(client, slug);
  }];
};
var useSingleIntegrationQuery = (0,createQueryHook/* default */.Z)(createSingleIntegrationQuery, contexts_staticSiteBackend/* useStaticSiteBackend */.gR, {
  staleTime: Infinity
});
// EXTERNAL MODULE: ../../libs/utils/deterministicShuffle/deterministicShuffle.ts
var deterministicShuffle = __webpack_require__(575);
;// CONCATENATED MODULE: ../../libs/api/routes/catalog/queries/similarIntegrationsQuery.ts






var similarIntegrationsAttributesToFetch = (/* unused pure expression or super */ null && (["contentType", "slug", "name", "logo", "categories", "type", "beta"]));
var fetchRandomSimilarIntegrations = /*#__PURE__*/function () {
  var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(_ref) {
    var catalogIndex, random, category, slug, data, similarIntegrations;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            catalogIndex = _ref.catalogIndex, random = _ref.random, category = _ref.category, slug = _ref.slug;
            _context.next = 3;
            return fetchIntegrations({
              catalogIndex: catalogIndex,
              query: "",
              distinct: 1,
              category: category,
              hitsPerPage: 20,
              destination: true,
              source: true
            });

          case 3:
            data = _context.sent;
            similarIntegrations = random ? (0,deterministicShuffle/* default */.Z)(data.hits) : data.hits;
            return _context.abrupt("return", similarIntegrations.filter(function (h) {
              return h.slug && normalizeSlug(h.slug) !== slug;
            }).slice(0, 4));

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchRandomSimilarIntegrations(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var normalizeSlug = function normalizeSlug(slug) {
  var startOffset = slug.startsWith("/") ? 1 : 0;
  var endOffset = slug.endsWith("/") ? -1 : 0;
  return slug.substring(startOffset, slug.length + endOffset);
};

var createSimilarIntegrationsQuery = function createSimilarIntegrationsQuery(catalogIndex, _ref3) {
  var slug = _ref3.slug,
      category = _ref3.category,
      random = _ref3.random,
      amount = _ref3.amount;
  return [["catalog/SimilarIntegrationsQuery", slug !== null && slug !== void 0 ? slug : null, category !== null && category !== void 0 ? category : null, random !== null && random !== void 0 ? random : null, amount !== null && amount !== void 0 ? amount : null], function () {
    return fetchRandomSimilarIntegrations({
      catalogIndex: catalogIndex,
      random: random,
      slug: slug,
      amount: amount,
      category: category
    });
  }];
};
var useSimilarIntegrationsQuery = (0,createQueryHook/* default */.Z)(createSimilarIntegrationsQuery, contexts_catalogIndex/* useCatalogIndex */.TO, {
  staleTime: Infinity
});
;// CONCATENATED MODULE: ../../libs/api/routes/catalog/queries/index.ts










/***/ }),

/***/ 39896:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "e": function() { return /* binding */ createClient; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(20406);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(28526);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
;// CONCATENATED MODULE: ../../libs/utils/retry/retry.ts



var wait = function wait(waitTime) {
  return new Promise(function (resolve) {
    setTimeout(resolve, waitTime);
  });
};

var numberSuffixes = ["st", "nd", "rd"];

var functionFailedText = function functionFailedText(iteration) {
  var _numberSuffixes$itera;

  return "Function failed. Retrying ".concat(iteration + 1).concat((_numberSuffixes$itera = numberSuffixes[iteration]) !== null && _numberSuffixes$itera !== void 0 ? _numberSuffixes$itera : "th", " time...");
};

var allRetriesFailedText = function allRetriesFailedText(retriesCount, errors) {
  return "Function failed too many times. Tired ".concat(retriesCount, " time").concat(retriesCount > 1 ? "s" : "", ".\nThrown errors:\n").concat(errors.map(function (e) {
    return e.toString();
  }).join("\n\n"), "\n");
};
/* eslint-disable no-await-in-loop */

/**
 * Retry function call
 * @param fn - The function to be called
 * @param options - The options object
 * @param options.times - Total amount of function calls. First function call is included.
 * @param options.waitTime - Wait time between retries in milliseconds
 * @returns The function with retries
 */


var retry = function retry(fn, _ref) {
  var times = _ref.times,
      waitTime = _ref.waitTime;
  return /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
    var errors,
        i,
        _args = arguments;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            errors = [];
            i = 0;

          case 2:
            if (!(i < times)) {
              _context.next = 19;
              break;
            }

            _context.prev = 3;
            _context.next = 6;
            return fn.apply(void 0, _args);

          case 6:
            return _context.abrupt("return", _context.sent);

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](3);
            console.log(functionFailedText(i));

            if (!(i + 1 < times)) {
              _context.next = 15;
              break;
            }

            _context.next = 15;
            return wait(waitTime);

          case 15:
            errors.push(_context.t0);

          case 16:
            i++;
            _context.next = 2;
            break;

          case 19:
            throw new Error(allRetriesFailedText(times, errors));

          case 20:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[3, 9]]);
  }));
};
/* eslint-enable no-await-in-loop */


/* harmony default export */ var retry_retry = (retry);
;// CONCATENATED MODULE: ../../libs/utils/retry/index.ts

;// CONCATENATED MODULE: ../../libs/api/staticSiteBackend/client.ts
/* provided dependency */ var process = __webpack_require__(34406);



var OMIT_CACHE_PARAMETER = "omitCache";
var CONTENT_PREVIEW_PARAMETER = "contentPreview";

var isCacheDisabled = function isCacheDisabled() {
  return process.env.CI;
};

var createClient = function createClient() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$retry = _ref.retry,
      retryOptions = _ref$retry === void 0 ? {
    times: 3,
    waitTime: 1000
  } : _ref$retry;

  function get(_x, _x2) {
    return _get.apply(this, arguments);
  }

  function _get() {
    _get = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(url, options) {
      var fullUserUrl, fullUrl, isOmitCacheParamMissing, startTime, response, json, endTime, requestTime;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!url.startsWith("/")) {
                _context.next = 20;
                break;
              }

              fullUserUrl = "".concat("https://segment.com/backend").concat(url);
              fullUrl = new URL(fullUserUrl);
              isOmitCacheParamMissing = !fullUrl.searchParams.has(OMIT_CACHE_PARAMETER);

              if (isOmitCacheParamMissing && isCacheDisabled()) {
                fullUrl.searchParams.append(OMIT_CACHE_PARAMETER, "");
              }

              if (process.env.IS_CONTENTFUL_PREVIEW_BRANCH === "true") {
                fullUrl.searchParams.append(CONTENT_PREVIEW_PARAMETER, "true");
              }

              startTime = Date.now();
              _context.next = 9;
              return fetch(fullUrl.toString(), options);

            case 9:
              response = _context.sent;

              if (!response.ok) {
                _context.next = 17;
                break;
              }

              _context.next = 13;
              return response.json();

            case 13:
              json = _context.sent;

              if (!(options !== null && options !== void 0 && options.responseHeaders)) {
                _context.next = 16;
                break;
              }

              return _context.abrupt("return", {
                data: json,
                headers: response.headers
              });

            case 16:
              return _context.abrupt("return", json);

            case 17:
              endTime = Date.now();
              requestTime = (endTime - startTime) / 1000;
              throw new Error("HTTP error ".concat(response.status, ": ").concat(response.statusText, "\nwhile trying to fetch: ").concat(fullUrl, "\nresponse returned after: ").concat(requestTime, " seconds\n      "));

            case 20:
              throw new Error("Client supports only absolute paths (starting with /)");

            case 21:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _get.apply(this, arguments);
  }

  var retryGet = retry_retry(get, retryOptions);
  return {
    get: retryGet
  };
};



/***/ }),

/***/ 72182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ CheckboxField; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/matcha/components/Checkbox/index.ts + 2 modules
var Checkbox = __webpack_require__(38128);
// EXTERNAL MODULE: ../../libs/matcha/components/Fieldset/FieldsetContext.tsx
var FieldsetContext = __webpack_require__(83734);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
;// CONCATENATED MODULE: ../../libs/matcha/components/CheckboxField/CheckboxField.views.ts


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}



var _ref =  true ? {
  name: "1k4lyc2",
  styles: "opacity:0.5;cursor:not-allowed"
} : 0;

var Label = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("label",  true ? {
  target: "e1e8l1r51"
} : 0)("display:grid;grid-template-columns:min-content auto;cursor:pointer;", function (_ref2) {
  var disabled = _ref2.disabled;
  return disabled && _ref;
}, ";" + ( true ? "" : 0));
var Text = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e1e8l1r50"
} : 0)( true ? {
  name: "1ym883w",
  styles: "margin:0;padding-left:12px"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/components/CheckboxField/CheckboxField.tsx


var _excluded = ["name", "label", "disabled", "onChange", "tokens"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}








var BaseCheckboxField = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var name = _ref.name,
      label = _ref.label,
      disabled = _ref.disabled,
      onChange = _ref.onChange,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var fieldsetContext = (0,FieldsetContext/* useFieldset */.w)();
  var isDisabled = disabled || (fieldsetContext === null || fieldsetContext === void 0 ? void 0 : fieldsetContext.disabledFieldset);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Label, {
    disabled: isDisabled,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Checkbox/* default */.Z, _objectSpread({
      name: name,
      disabled: Boolean(isDisabled),
      onChange: onChange,
      ref: ref,
      tokens: tokens.checkbox
    }, rest)), typeof label === "string" ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text, {
      variant: "formInput",
      tokens: tokens.label,
      children: label
    }) : label]
  });
});
var CheckboxField = (0,useDesignTokens/* withDesignTokens */.Y)(BaseCheckboxField, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      checkbox: {},
      label: {
        color: theme.palette.brand.darkAcai[500]
      }
    };
  },
  dark: function dark(theme) {
    return {
      checkbox: {},
      label: {
        color: theme.palette.brand.darkAcai[400]
      }
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      checkbox: {},
      label: {
        color: theme.palette.twilio.gray[100]
      }
    };
  }
});
;// CONCATENATED MODULE: ../../libs/matcha/components/CheckboxField/index.ts


/***/ }),

/***/ 54086:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ SearchBar; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Brandbook.ts + 93 modules
var Brandbook = __webpack_require__(52065);
// EXTERNAL MODULE: ../../libs/matcha/components/Input/index.ts + 2 modules
var Input = __webpack_require__(94261);
// EXTERNAL MODULE: ../../libs/matcha/components/Loader/index.ts
var Loader = __webpack_require__(37438);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/components/SearchBar/SearchBar.tsx


var _excluded = ["name", "id", "placeholder", "required", "error", "value", "expanded", "onChange", "onClear", "disabled", "appearance", "isLoading", "dataHook"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}






var SearchBar = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var name = _ref.name,
      id = _ref.id,
      placeholder = _ref.placeholder,
      required = _ref.required,
      error = _ref.error,
      value = _ref.value,
      expanded = _ref.expanded,
      onChange = _ref.onChange,
      onClear = _ref.onClear,
      disabled = _ref.disabled,
      appearance = _ref.appearance,
      isLoading = _ref.isLoading,
      dataHook = _ref.dataHook,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input/* default */.Z, _objectSpread({
    type: "search",
    icon: isLoading ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Loader/* default */.Z, {
      size: "small"
    }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Brandbook/* SearchIcon */.W1, {}),
    resetable: true,
    name: name,
    id: id,
    placeholder: placeholder,
    required: required,
    disabled: disabled,
    value: value,
    onChange: onChange,
    onClear: onClear,
    appearance: appearance,
    error: error,
    ref: ref,
    expanded: expanded,
    dataHook: dataHook
  }, rest));
});
;// CONCATENATED MODULE: ../../libs/matcha/components/SearchBar/index.ts


/***/ }),

/***/ 75420:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "k": function() { return /* reexport */ CONFIG; },
  "Z": function() { return /* reexport */ CardsGrid_CardsGrid; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/CardsGrid/CardsGrid.views.tsx


var CONFIG = {
  itemsLimit: {
    mobile: 4,
    desktop: 8
  }
};
var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1w5dbk90"
} : 0)("width:100%;display:grid;gap:16px;grid-template-columns:repeat(auto-fill, minmax(190px, 1fr));", function (_ref) {
  var limitItems = _ref.limitItems,
      theme = _ref.theme;
  return limitItems &&
  /*#__PURE__*/

  /*#__PURE__*/
  (0,emotion_react_browser_esm/* css */.iv)(theme.breakpoints.down("sm"), "{*:nth-of-type(n + ", CONFIG.itemsLimit.mobile + 1, "){display:none;}}", theme.breakpoints.up("md"), "{*:nth-of-type(n + ", CONFIG.itemsLimit.desktop + 1, "){display:none;}}" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);
}, " ", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("md");
}, "{gap:24px;}", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("xl");
}, "{gap:32px;}" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/CardsGrid/CardsGrid.tsx


var _excluded = ["children"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}




var CardsGrid = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, _objectSpread(_objectSpread({
    ref: ref
  }, props), {}, {
    children: children
  }));
});
/* harmony default export */ var CardsGrid_CardsGrid = (CardsGrid);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/CardsGrid/index.ts



/***/ }),

/***/ 31714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MI": function() { return /* binding */ SignupButton; },
/* harmony export */   "_f": function() { return /* binding */ SignupButtonText; }
/* harmony export */ });
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82269);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _segment_matcha_components_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33445);
/* harmony import */ var _segment_matcha_components_ButtonText__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74870);
/* harmony import */ var _segment_contexts_page__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17782);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52903);


var _excluded = ["color", "variant", "size", "expanded", "children", "additionalParams", "linkToApp"],
    _excluded2 = ["appearance", "children", "additionalParams", "linkToApp"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}







var useTransformUrl = function useTransformUrl(customQuery, linkToApp) {
  var _usePageConfig = (0,_segment_contexts_page__WEBPACK_IMPORTED_MODULE_4__/* .usePageConfig */ .Gm)(),
      queryParamsFromCookie = _usePageConfig.queryParamsFromCookie,
      appUrl = _usePageConfig.appUrl;

  var hostUrl = linkToApp ? appUrl : "https://segment.com";
  var queryString = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    var query = new URLSearchParams(queryParamsFromCookie);

    for (var qs in customQuery) {
      query.append(qs, customQuery[qs]);
    }

    return query.toString() ? "?".concat(query.toString()) : "";
  }, [queryParamsFromCookie, customQuery]);
  return "".concat(hostUrl, "/signup/").concat(queryString);
};

var SignupButton = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_ref, ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "primary" : _ref$color,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "filled" : _ref$variant,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "large" : _ref$size,
      expanded = _ref.expanded,
      children = _ref.children,
      additionalParams = _ref.additionalParams,
      _ref$linkToApp = _ref.linkToApp,
      linkToApp = _ref$linkToApp === void 0 ? false : _ref$linkToApp,
      rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref, _excluded);

  var url = useTransformUrl(additionalParams, linkToApp);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_segment_matcha_components_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread(_objectSpread({
    variant: variant,
    size: size,
    color: color,
    expanded: expanded,
    tag: "a",
    href: url,
    ref: ref
  }, rest), {}, {
    children: children
  }));
});
var SignupButtonText = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_ref2, ref) {
  var externalAppearance = _ref2.appearance,
      children = _ref2.children,
      additionalParams = _ref2.additionalParams,
      _ref2$linkToApp = _ref2.linkToApp,
      linkToApp = _ref2$linkToApp === void 0 ? false : _ref2$linkToApp,
      rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref2, _excluded2);

  var url = useTransformUrl(additionalParams, linkToApp);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_segment_matcha_components_ButtonText__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, _objectSpread(_objectSpread({
    ref: ref,
    href: url,
    appearance: externalAppearance
  }, rest), {}, {
    children: children
  }));
});
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (SignupButton)));

/***/ }),

/***/ 77931:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _SignupButton__WEBPACK_IMPORTED_MODULE_0__.MI; },
/* harmony export */   "_": function() { return /* reexport safe */ _SignupButton__WEBPACK_IMPORTED_MODULE_0__._f; }
/* harmony export */ });
/* harmony import */ var _SignupButton__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31714);


/***/ }),

/***/ 42576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ GettingStarted; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Common.ts + 14 modules
var Common = __webpack_require__(6580);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/matcha/recipes/SignupButton/index.ts
var SignupButton = __webpack_require__(77931);
// EXTERNAL MODULE: ../../libs/templates/LogoTiles/index.ts + 1 modules
var LogoTiles = __webpack_require__(20442);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/templates/GettingStarted/GettingStarted.views.tsx

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1044f9v2"
} : 0)("overflow-y:auto;overflow-x:hidden;padding-top:80px;background:", function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return backgroundColor;
}, ";" + ( true ? "" : 0));
var Copy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1044f9v1"
} : 0)("display:grid;justify-content:center;row-gap:40px;padding:0 20px;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("md");
}, "{padding:80px 80px 30px;}" + ( true ? "" : 0));
var Content = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1044f9v0"
} : 0)("display:grid;max-width:540px;width:100%;margin:0 auto;grid-template-columns:1fr 1fr;grid-template-rows:auto;gap:24px;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.down("sm");
}, "{grid-template-columns:auto;max-width:327px;}" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/GettingStarted/GettingStarted.tsx


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}













var BaseGettingStarted = function BaseGettingStarted(_ref) {
  var _ref$heading = _ref.heading,
      heading = _ref$heading === void 0 ? "Getting started is easy" : _ref$heading,
      _ref$description = _ref.description,
      description = _ref$description === void 0 ? "Start connecting your data with Segment." : _ref$description,
      _ref$demoUtms = _ref.demoUtms,
      demoUtms = _ref$demoUtms === void 0 ? "" : _ref$demoUtms,
      tokens = _ref.tokens;
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, _objectSpread(_objectSpread({}, tokens), {}, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Copy, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        centered: true,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h3",
          variant: "h2",
          children: heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          tag: "p",
          variant: "pLarge",
          children: description
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Content, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
          size: "large",
          color: "primary",
          variant: "filled",
          tag: "a",
          href: (0,getAbsoluteUrl/* default */.Z)("/demo/".concat(demoUtms), pageConfig),
          children: "Get a demo"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SignupButton/* default */.Z, {
          tag: "a",
          variant: "outlined",
          iconEnd: Common/* ChevronRightIcon */.XC,
          children: "Create a free account"
        })]
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoTiles/* default */.Z, {})]
  }));
};

var GettingStarted = (0,useDesignTokens/* withDesignTokens */.Y)(BaseGettingStarted, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      backgroundColor: theme.palette.neutrals.cloud[100]
    };
  },
  dark: function dark(theme) {
    return {
      backgroundColor: theme.palette.brand.darkAcai[700]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      backgroundColor: theme.palette.twilio.gray[10]
    };
  }
});
;// CONCATENATED MODULE: ../../libs/templates/GettingStarted/index.ts


/***/ }),

/***/ 1959:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/**
 * A helper function to generate the path to an image from Contentful.
 * @param props.src - The path to the image
 * @param props.width - The width of the image
 * @param props.quality - The quality of the image
 * @returns The path to the image with the width and quality parameters
 */
var contentfulImageLoader = function contentfulImageLoader(_ref) {
  var src = _ref.src,
      width = _ref.width,
      quality = _ref.quality;
  return "".concat(src, "?w=").concat(width, "&q=").concat(quality || 75);
};

/* harmony default export */ __webpack_exports__["Z"] = (contentfulImageLoader);

/***/ }),

/***/ 99338:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12741);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58586);



function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}


/**
 * Creates infinite query hook from query factory
 *
 * @param fetchFactory factory function creating [query key, fetchFunction] tuple for use with react-query lib
 * @param useClientInstance hook function returning client instance to use with fetching function
 * @returns hook function wrapping useInfiniteQuery
 */

var createInfiniteQueryHook = function createInfiniteQueryHook(fetchFactory, useClientInstance, defaultOptions) {
  return function (_ref) {
    var args = _ref.args,
        options = _ref.options;
    var instance = useClientInstance();
    return _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useInfiniteQuery.apply */ .N.apply(void 0, (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(fetchFactory.apply(void 0, [instance].concat((0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(args)))).concat([_objectSpread(_objectSpread({}, defaultOptions), options)]));
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (createInfiniteQueryHook);

/***/ }),

/***/ 575:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export shuffleWithSeed */
// SOURCE: https://github.com/yixizhang/seed-shuffle

/**
 * This is an util to generate a shuffled array, with deterministic randomness provided by the seed.
 *
 * @param array - The array to be shuffled
 * @param seed - The seed to generate the randomness
 * @returns The shuffled array
 */
var shuffleWithSeed = function shuffleWithSeed(array) {
  var seed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1332712639;
  var currentIndex = array.length;
  var temporaryValue;
  var randomIndex;
  seed = seed || 1;

  var random = function random() {
    var x = Math.sin(seed++) * 10000;
    return x - Math.floor(x);
  }; // While there remain elements to shuffle...


  while (currentIndex !== 0) {
    // Pick a remaining element...
    randomIndex = Math.floor(random() * currentIndex);
    currentIndex -= 1; // And swap it with the current element.

    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }

  return array;
};

var deterministicShuffle = function deterministicShuffle(array, someRandom) {
  return shuffleWithSeed(array, someRandom);
};

/* harmony default export */ __webpack_exports__["Z"] = (deterministicShuffle);

/***/ }),

/***/ 63009:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ useMaskOnScroll_useMaskOnScroll; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(7328);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(81333);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/value/use-motion-value.mjs
var use_motion_value = __webpack_require__(21687);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/value/scroll/use-element-scroll.mjs
var use_element_scroll = __webpack_require__(66057);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/value/use-transform.mjs + 1 modules
var use_transform = __webpack_require__(29682);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/value/use-motion-template.mjs
var use_motion_template = __webpack_require__(85770);
// EXTERNAL MODULE: ../../libs/utils/useResizeObserver/index.ts + 1 modules
var useResizeObserver = __webpack_require__(73889);
;// CONCATENATED MODULE: ../../libs/utils/useMaskOnScroll/useMaskOnScroll.ts



var _templateObject;




/**
 * A hook to create a mask on scroll
 * @param props.wrapper - A ref to the element to observe
 * @param props.axis - The axis to apply the mask
 * @param props.offset - The offset to apply to the mask
 * @returns A string to use as a mask
 */

var useMaskOnScroll = function useMaskOnScroll(_ref) {
  var wrapper = _ref.wrapper,
      _ref$axis = _ref.axis,
      axis = _ref$axis === void 0 ? "horizontal" : _ref$axis,
      _ref$offset = _ref.offset,
      offset = _ref$offset === void 0 ? "8%" : _ref$offset;
  var clientValue = (0,use_motion_value/* useMotionValue */.c)(0);
  var scrollValue = (0,use_motion_value/* useMotionValue */.c)(0);
  var sizeValue = (0,use_motion_value/* useMotionValue */.c)(0);

  var _useElementScroll = (0,use_element_scroll/* useElementScroll */.B)(wrapper),
      scrollYProgress = _useElementScroll.scrollYProgress,
      scrollXProgress = _useElementScroll.scrollXProgress;

  var isVertical = axis === "vertical";
  var scrollProgress = isVertical ? scrollYProgress : scrollXProgress;
  var values = /^([-.\d]+(?:\.\d+)?)(.*)$/.exec(offset);
  var degs = isVertical ? (0,use_motion_value/* useMotionValue */.c)(180) : (0,use_motion_value/* useMotionValue */.c)(90);
  var unit = (0,use_motion_value/* useMotionValue */.c)(values && values[2]);
  var offsetValue = values ? Number(values[1]) : 0;

  if (isVertical) {
    var _wrapper$current;

    sizeValue.set(unit.get() === "%" ? 100 : Number((_wrapper$current = wrapper.current) === null || _wrapper$current === void 0 ? void 0 : _wrapper$current.getBoundingClientRect().height));
  } else {
    var _wrapper$current2;

    sizeValue.set(unit.get() === "%" ? 100 : Number((_wrapper$current2 = wrapper.current) === null || _wrapper$current2 === void 0 ? void 0 : _wrapper$current2.getBoundingClientRect().width));
  }

  (0,react.useEffect)(function () {
    if (unit.get() === "%") return;

    var handleResize = function handleResize() {
      if (isVertical) {
        var _wrapper$current3;

        sizeValue.set(Number((_wrapper$current3 = wrapper.current) === null || _wrapper$current3 === void 0 ? void 0 : _wrapper$current3.getBoundingClientRect().height));
      } else {
        var _wrapper$current4;

        sizeValue.set(Number((_wrapper$current4 = wrapper.current) === null || _wrapper$current4 === void 0 ? void 0 : _wrapper$current4.getBoundingClientRect().width));
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return function () {
      return window.removeEventListener("resize", handleResize);
    };
  }, [isVertical, unit]);
  var maskStartSize = (0,use_transform/* useTransform */.H)([clientValue, scrollValue, scrollProgress], function (_ref2) {
    var _ref3 = (0,slicedToArray/* default */.Z)(_ref2, 3),
        clientValue = _ref3[0],
        scrollValue = _ref3[1],
        scrollProgressValue = _ref3[2];

    return clientValue === scrollValue ? 0 : Math.min(offsetValue, scrollProgressValue * sizeValue.get());
  });
  var maskEndSize = (0,use_transform/* useTransform */.H)([clientValue, scrollValue, scrollProgress], function (_ref4) {
    var _ref5 = (0,slicedToArray/* default */.Z)(_ref4, 3),
        clientValue = _ref5[0],
        scrollValue = _ref5[1],
        scrollProgressValue = _ref5[2];

    return clientValue === scrollValue ? sizeValue.get() : Math.max(sizeValue.get() - offsetValue, scrollProgressValue * sizeValue.get());
  });
  var maskImage = (0,use_motion_template/* useMotionTemplate */.Y)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["linear-gradient(", "deg, rgba(0,0,0,0) 0", ", rgba(0,0,0,1) ", "", ", rgba(0,0,0,1) ", "", ", rgba(0,0,0,0) ", "", ")"])), degs, unit, maskStartSize, unit, maskEndSize, unit, sizeValue, unit);
  var setValue = (0,react.useCallback)(function () {
    var _ref6, _wrapper$current5, _wrapper$current6, _ref7, _wrapper$current7, _wrapper$current8;

    clientValue.set((_ref6 = isVertical ? (_wrapper$current5 = wrapper.current) === null || _wrapper$current5 === void 0 ? void 0 : _wrapper$current5.clientHeight : (_wrapper$current6 = wrapper.current) === null || _wrapper$current6 === void 0 ? void 0 : _wrapper$current6.clientWidth) !== null && _ref6 !== void 0 ? _ref6 : 0);
    scrollValue.set((_ref7 = isVertical ? (_wrapper$current7 = wrapper.current) === null || _wrapper$current7 === void 0 ? void 0 : _wrapper$current7.scrollHeight : (_wrapper$current8 = wrapper.current) === null || _wrapper$current8 === void 0 ? void 0 : _wrapper$current8.scrollWidth) !== null && _ref7 !== void 0 ? _ref7 : 0);
  }, [clientValue, wrapper, scrollValue]);
  (0,useResizeObserver/* default */.Z)(wrapper, setValue);
  (0,react.useEffect)(function () {
    return setValue();
  }, [setValue]);
  return maskImage;
};

/* harmony default export */ var useMaskOnScroll_useMaskOnScroll = (useMaskOnScroll);
;// CONCATENATED MODULE: ../../libs/utils/useMaskOnScroll/index.ts


/***/ }),

/***/ 78299:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ useNextPageTrigger_useNextPageTrigger; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/utils/useIntersectionObserver/index.ts + 1 modules
var useIntersectionObserver = __webpack_require__(83194);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/utils/useNextPageTrigger/useNextPageTrigger.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}




/**
 * A hook that triggers the next page when the element is in view.
 * @param props.isLoading Whether the next page is loading.
 * @param props.onNextPage The function to call when the next page should be loaded.
 * @param props.loadMargin The margin to use when loading the next page.
 * @param props.totalDownloadedPages The total number of downloaded pages.
 * @param props.hasNextPage Whether there is a next page.
 * @param props.error The error that occurred while loading the next page.
 * @param props.NextPageTrigger The component to render as the next page trigger.
 * @returns The React component to render as the next page trigger.
 */

var useNextPageTrigger = function useNextPageTrigger(_ref) {
  var isLoading = _ref.isLoading,
      onNextPage = _ref.onNextPage,
      loadMargin = _ref.loadMargin,
      pageLength = _ref.totalDownloadedPages,
      hasNextPage = _ref.hasNextPage,
      error = _ref.error,
      _ref$NextPageTrigger = _ref.NextPageTrigger,
      NextPageTrigger = _ref$NextPageTrigger === void 0 ? DefaultNextPageTrigger : _ref$NextPageTrigger;
  var nextPageTriggerRef = (0,react.useRef)(null);
  var isInView = (0,react.useRef)(false);
  (0,useIntersectionObserver/* default */.Z)([nextPageTriggerRef], function (intersections) {
    var isInViewValue = intersections.some(function (i) {
      return i.isIntersecting;
    });
    isInView.current = isInViewValue;

    if (isLoading) {
      return;
    }

    if (isInViewValue && hasNextPage) {
      onNextPage === null || onNextPage === void 0 ? void 0 : onNextPage();
    }
  }, {
    rootMargin: loadMargin,
    threshold: [1]
  });
  (0,react.useEffect)(function () {
    if (!isLoading && isInView.current && hasNextPage) {
      // eslint-disable-next-line no-warning-comments
      // TODO: This `onNextPage()` call should be revisited since it is fetching pagination data twice
      // check out on /customers, /recipes, /catalog, /growth-masters/curriculum
      // Maybe we should remove this useEffect entirely and refactor this hook.
      onNextPage === null || onNextPage === void 0 ? void 0 : onNextPage();
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [isLoading, pageLength, hasNextPage]); // Split it to simplify typescript compilation

  var El = NextPageTrigger;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(El, {
    ref: nextPageTriggerRef,
    error: error
  });
};

/* harmony default export */ var useNextPageTrigger_useNextPageTrigger = (useNextPageTrigger);

var DefaultNextPageTrigger = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e11u9tnv0"
} : 0)( true ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : 0);
;// CONCATENATED MODULE: ../../libs/utils/useNextPageTrigger/index.ts


/***/ }),

/***/ 73889:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ useResizeObserver_useResizeObserver; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/resize-observer-polyfill/dist/ResizeObserver.es.js
var ResizeObserver_es = __webpack_require__(97209);
;// CONCATENATED MODULE: ../../libs/utils/useResizeObserver/useResizeObserver.ts


/**
 * The useResizeObserver reports changes to the dimensions of an element's content or border box
 * @param ref - A ref to the element to observe
 * @param fn - A callback function called when size of the observed element change
 */

var useResizeObserver = function useResizeObserver(ref, fn) {
  (0,react.useEffect)(function () {
    var resizeObserver = new ResizeObserver_es/* default */.Z(function () {
      fn();
    });

    if (ref !== null && ref !== void 0 && ref.current) {
      resizeObserver.observe(ref.current);
    }

    return function () {
      resizeObserver.disconnect();
    };
  }, [fn, ref]);
};

/* harmony default export */ var useResizeObserver_useResizeObserver = (useResizeObserver);
;// CONCATENATED MODULE: ../../libs/utils/useResizeObserver/index.ts


/***/ }),

/***/ 63978:
/***/ (function(module) {

module.exports = "/_next/static/images/OgCatalog-dc0f7c2b805a516d6a707c1c0572b09f.png";

/***/ }),

/***/ 66057:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ useElementScroll; }
/* harmony export */ });
/* harmony import */ var _utils_use_constant_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3105);
/* harmony import */ var _utils_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7622);
/* harmony import */ var _events_use_dom_event_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27723);
/* harmony import */ var _utils_use_isomorphic_effect_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23617);
/* harmony import */ var hey_listen__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9340);






var getElementScrollOffsets = function (element) { return function () {
    return {
        xOffset: element.scrollLeft,
        yOffset: element.scrollTop,
        xMaxOffset: element.scrollWidth - element.offsetWidth,
        yMaxOffset: element.scrollHeight - element.offsetHeight,
    };
}; };
/**
 * Returns MotionValues that update when the provided element scrolls:
 *
 * - `scrollX` — Horizontal scroll distance in pixels.
 * - `scrollY` — Vertical scroll distance in pixels.
 * - `scrollXProgress` — Horizontal scroll progress between `0` and `1`.
 * - `scrollYProgress` — Vertical scroll progress between `0` and `1`.
 *
 * This element must be set to `overflow: scroll` on either or both axes to report scroll offset.
 *
 * ```jsx
 * export const MyComponent = () => {
 *   const ref = useRef()
 *   const { scrollYProgress } = useElementScroll(ref)
 *
 *   return (
 *     <div ref={ref}>
 *       <motion.div style={{ scaleX: scrollYProgress }} />
 *     </div>
 *   )
 * }
 * ```
 *
 * @public
 */
function useElementScroll(ref) {
    var values = (0,_utils_use_constant_mjs__WEBPACK_IMPORTED_MODULE_0__/* .useConstant */ .h)(_utils_mjs__WEBPACK_IMPORTED_MODULE_1__/* .createScrollMotionValues */ .w);
    (0,_utils_use_isomorphic_effect_mjs__WEBPACK_IMPORTED_MODULE_2__/* .useIsomorphicLayoutEffect */ .L)(function () {
        var element = ref.current;
        (0,hey_listen__WEBPACK_IMPORTED_MODULE_3__/* .invariant */ .k)(!!element, "ref provided to useScroll must be passed into a HTML element.");
        if (!element)
            return;
        var updateScrollValues = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__/* .createScrollUpdater */ .S)(values, getElementScrollOffsets(element));
        var scrollListener = (0,_events_use_dom_event_mjs__WEBPACK_IMPORTED_MODULE_4__/* .addDomEvent */ .E)(element, "scroll", updateScrollValues);
        var resizeListener = (0,_events_use_dom_event_mjs__WEBPACK_IMPORTED_MODULE_4__/* .addDomEvent */ .E)(element, "resize", updateScrollValues);
        return function () {
            scrollListener && scrollListener();
            resizeListener && resizeListener();
        };
    }, []);
    return values;
}




/***/ }),

/***/ 7622:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ createScrollUpdater; },
/* harmony export */   "w": function() { return /* binding */ createScrollMotionValues; }
/* harmony export */ });
/* harmony import */ var _index_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40226);


function createScrollMotionValues() {
    return {
        scrollX: (0,_index_mjs__WEBPACK_IMPORTED_MODULE_0__/* .motionValue */ .B)(0),
        scrollY: (0,_index_mjs__WEBPACK_IMPORTED_MODULE_0__/* .motionValue */ .B)(0),
        scrollXProgress: (0,_index_mjs__WEBPACK_IMPORTED_MODULE_0__/* .motionValue */ .B)(0),
        scrollYProgress: (0,_index_mjs__WEBPACK_IMPORTED_MODULE_0__/* .motionValue */ .B)(0),
    };
}
function setProgress(offset, maxOffset, value) {
    value.set(!offset || !maxOffset ? 0 : offset / maxOffset);
}
function createScrollUpdater(values, getOffsets) {
    var update = function () {
        var _a = getOffsets(), xOffset = _a.xOffset, yOffset = _a.yOffset, xMaxOffset = _a.xMaxOffset, yMaxOffset = _a.yMaxOffset;
        // Set absolute positions
        values.scrollX.set(xOffset);
        values.scrollY.set(yOffset);
        // Set 0-1 progress
        setProgress(xOffset, xMaxOffset, values.scrollXProgress);
        setProgress(yOffset, yMaxOffset, values.scrollYProgress);
    };
    update();
    return update;
}




/***/ }),

/***/ 77014:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ useCombineMotionValues; }
/* harmony export */ });
/* harmony import */ var _use_motion_value_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21687);
/* harmony import */ var _use_on_change_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29709);
/* harmony import */ var framesync__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76432);




function useCombineMotionValues(values, combineValues) {
    /**
     * Initialise the returned motion value. This remains the same between renders.
     */
    var value = (0,_use_motion_value_mjs__WEBPACK_IMPORTED_MODULE_1__/* .useMotionValue */ .c)(combineValues());
    /**
     * Create a function that will update the template motion value with the latest values.
     * This is pre-bound so whenever a motion value updates it can schedule its
     * execution in Framesync. If it's already been scheduled it won't be fired twice
     * in a single frame.
     */
    var updateValue = function () { return value.set(combineValues()); };
    /**
     * Synchronously update the motion value with the latest values during the render.
     * This ensures that within a React render, the styles applied to the DOM are up-to-date.
     */
    updateValue();
    /**
     * Subscribe to all motion values found within the template. Whenever any of them change,
     * schedule an update.
     */
    (0,_use_on_change_mjs__WEBPACK_IMPORTED_MODULE_2__/* .useMultiOnChange */ .f)(values, function () { return framesync__WEBPACK_IMPORTED_MODULE_0__/* ["default"].update */ .ZP.update(updateValue, false, true); });
    return value;
}




/***/ }),

/***/ 85770:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ useMotionTemplate; }
/* harmony export */ });
/* harmony import */ var _use_combine_values_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77014);


/**
 * Combine multiple motion values into a new one using a string template literal.
 *
 * ```jsx
 * import {
 *   motion,
 *   useSpring,
 *   useMotionValue,
 *   useMotionTemplate
 * } from "framer-motion"
 *
 * function Component() {
 *   const shadowX = useSpring(0)
 *   const shadowY = useMotionValue(0)
 *   const shadow = useMotionTemplate`drop-shadow(${shadowX}px ${shadowY}px 20px rgba(0,0,0,0.3))`
 *
 *   return <motion.div style={{ filter: shadow }} />
 * }
 * ```
 *
 * @public
 */
function useMotionTemplate(fragments) {
    var values = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        values[_i - 1] = arguments[_i];
    }
    /**
     * Create a function that will build a string from the latest motion values.
     */
    var numFragments = fragments.length;
    function buildValue() {
        var output = "";
        for (var i = 0; i < numFragments; i++) {
            output += fragments[i];
            var value = values[i];
            if (value)
                output += values[i].get();
        }
        return output;
    }
    return (0,_use_combine_values_mjs__WEBPACK_IMPORTED_MODULE_0__/* .useCombineMotionValues */ .N)(values, buildValue);
}




/***/ }),

/***/ 21687:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ useMotionValue; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41412);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _index_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40226);
/* harmony import */ var _context_MotionConfigContext_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60976);
/* harmony import */ var _utils_use_constant_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3105);






/**
 * Creates a `MotionValue` to track the state and velocity of a value.
 *
 * Usually, these are created automatically. For advanced use-cases, like use with `useTransform`, you can create `MotionValue`s externally and pass them into the animated component via the `style` prop.
 *
 * ```jsx
 * export const MyComponent = () => {
 *   const scale = useMotionValue(1)
 *
 *   return <motion.div style={{ scale }} />
 * }
 * ```
 *
 * @param initial - The initial state.
 *
 * @public
 */
function useMotionValue(initial) {
    var value = (0,_utils_use_constant_mjs__WEBPACK_IMPORTED_MODULE_1__/* .useConstant */ .h)(function () { return (0,_index_mjs__WEBPACK_IMPORTED_MODULE_2__/* .motionValue */ .B)(initial); });
    /**
     * If this motion value is being used in static mode, like on
     * the Framer canvas, force components to rerender when the motion
     * value is updated.
     */
    var isStatic = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_context_MotionConfigContext_mjs__WEBPACK_IMPORTED_MODULE_3__/* .MotionConfigContext */ ._).isStatic;
    if (isStatic) {
        var _a = (0,tslib__WEBPACK_IMPORTED_MODULE_4__/* .__read */ .CR)((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initial), 2), setLatest_1 = _a[1];
        (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () { return value.onChange(setLatest_1); }, []);
    }
    return value;
}




/***/ }),

/***/ 29709:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ useMultiOnChange; },
/* harmony export */   "p": function() { return /* binding */ useOnChange; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _utils_is_motion_value_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15815);



function useOnChange(value, callback) {
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        if ((0,_utils_is_motion_value_mjs__WEBPACK_IMPORTED_MODULE_1__/* .isMotionValue */ .i)(value))
            return value.onChange(callback);
    }, [callback]);
}
function useMultiOnChange(values, handler) {
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        var subscriptions = values.map(function (value) { return value.onChange(handler); });
        return function () { return subscriptions.forEach(function (unsubscribe) { return unsubscribe(); }); };
    });
}




/***/ }),

/***/ 29682:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": function() { return /* binding */ useTransform; }
});

// EXTERNAL MODULE: ../../node_modules/framer-motion/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(41412);
// EXTERNAL MODULE: ../../node_modules/popmotion/dist/es/utils/interpolate.mjs + 3 modules
var interpolate = __webpack_require__(1560);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/utils/transform.mjs



var isCustomValueType = function (v) {
    return typeof v === "object" && v.mix;
};
var getMixer = function (v) { return (isCustomValueType(v) ? v.mix : undefined); };
function transform() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var useImmediate = !Array.isArray(args[0]);
    var argOffset = useImmediate ? 0 : -1;
    var inputValue = args[0 + argOffset];
    var inputRange = args[1 + argOffset];
    var outputRange = args[2 + argOffset];
    var options = args[3 + argOffset];
    var interpolator = (0,interpolate/* interpolate */.s)(inputRange, outputRange, (0,tslib_es6/* __assign */.pi)({ mixer: getMixer(outputRange[0]) }, options));
    return useImmediate ? interpolator(inputValue) : interpolator;
}



// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/value/use-combine-values.mjs
var use_combine_values = __webpack_require__(77014);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/utils/use-constant.mjs
var use_constant = __webpack_require__(3105);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/value/use-transform.mjs





function useTransform(input, inputRangeOrTransformer, outputRange, options) {
    var transformer = typeof inputRangeOrTransformer === "function"
        ? inputRangeOrTransformer
        : transform(inputRangeOrTransformer, outputRange, options);
    return Array.isArray(input)
        ? useListTransform(input, transformer)
        : useListTransform([input], function (_a) {
            var _b = (0,tslib_es6/* __read */.CR)(_a, 1), latest = _b[0];
            return transformer(latest);
        });
}
function useListTransform(values, transformer) {
    var latest = (0,use_constant/* useConstant */.h)(function () { return []; });
    return (0,use_combine_values/* useCombineMotionValues */.N)(values, function () {
        latest.length = 0;
        var numValues = values.length;
        for (var i = 0; i < numValues; i++) {
            latest[i] = values[i].get();
        }
        return transformer(latest);
    });
}




/***/ })

}]);